(function bootstrapOpticalHAdvisor(scope) {
  'use strict';

  const VERSION = 'premium_v10_editorial_type';
  const MAX_QUERY_LENGTH = 240;
  const MAX_REFINEMENT_QUERY_LENGTH = 180;
  const MAX_REFINEMENTS = 3;
  const MAX_TRACKED_RESULTS = 36;
  const MAX_COMPARE = 3;
  const SUPPORTED_LOCALES = new Set(['es', 'en', 'fr', 'de', 'ru', 'zh']);
  const ENTRY_SOURCES = new Set(['topbar', 'home', 'collection', 'direct']);
  const ANSWER_FIELDS = new Set([
    'product_type', 'colors', 'materials', 'shapes', 'styles', 'lens_filters',
    'brands', 'sport_use', 'lens_needs', 'fit',
    'in_stock', 'on_sale', 'rimless', 'budget'
  ]);
  const SAFE_CRITERIA = new Set([
    'product_type', 'colors', 'materials', 'shapes', 'styles', 'lens_filters',
    'brands', 'sport_use', 'lens_needs', 'fit',
    'in_stock', 'on_sale', 'rimless', 'budget'
  ]);
  const SAFE_ATTRIBUTES = new Set([
    'availability', 'brand', 'bridge', 'color', 'dimensions', 'fit', 'frame',
    'lens', 'lens_width', 'material', 'shape', 'size', 'temple', 'type', 'weight'
  ]);
  const BLOCKED_STATE_KEY = /(?:address|diagnos|email|free.?text|full.?name|input|name|phone|prescription|query|raw|selfie|text)/i;
  const EMAIL_LIKE = /\b[^\s@]+@[^\s@]+\.[^\s@]+\b/;
  const PHONE_LIKE = /(?:\+?\d[\s().-]*){8,}/;
  const ANALYTICS_ACTIONS = new Set([
    'advisor_open', 'mode_selected', 'intent_submitted', 'guided_started',
    'question_answered', 'question_skipped', 'preference_removed',
    'preference_refined', 'refinement_submitted', 'refinement_rejected',
    'refinement_limit_reached', 'more_options_requested', 'results_viewed', 'alternatives_opened',
    'product_impression', 'compare_added', 'compare_removed', 'compare_opened', 'product_opened',
    'no_results', 'handoff_shown', 'professional_help_opened', 'currency_unverified', 'fallback_used',
    'request_error', 'advisor_reset'
  ]);
  const ANALYTICS_FIELDS = new Set([
    'count', 'entry_source', 'match_tier', 'mode', 'product_id', 'question_id', 'reason',
    'result_count', 'round', 'selected_count', 'source', 'stage', 'position'
  ]);

  const COPY = {
    es: {
      loading: 'Estamos revisando el catálogo para ti…',
      queryRequired: 'Cuéntanos brevemente cómo serían tus gafas ideales.',
      questionRequired: 'Selecciona una opción o elige “No lo sé / Saltar”.',
    questionRequiredChoice: 'Selecciona una opción para continuar.',
      retryQuery: 'No hemos podido conectar. Tu descripción sigue en el campo para que puedas revisarla y enviarla de nuevo.',
      retryRefinement: 'No hemos podido aplicar el ajuste. El detalle sigue en el campo para que puedas revisarlo y enviarlo de nuevo.',
      retrySafe: 'La conexión ha fallado. Puedes reintentar sin repetir tus respuestas.',
      timeout: 'La respuesta está tardando más de lo esperado.',
      invalidResponse: 'La respuesta no contiene recomendaciones utilizables.',
      guidedLoading: 'Empecemos por lo importante…',
      refining: 'Actualizando tus preferencias…',
      moreLoading: 'Buscando modelos que todavía no has visto…',
      moreOptions: 'Prefiero ver otra selección',
      refinementRequired: 'Añade un detalle concreto para afinar las opciones.',
      refinementHelp: 'Puedes indicar color, forma, marca, deporte, lente, ajuste o un presupuesto con una cifra.',
      refinementProgress: (next, total) => `Ajuste ${next} de ${total}`,
      refinementRemaining: remaining => remaining === 1 ? 'Después te quedará un ajuste más.' : `Después te quedarán ${remaining} ajustes más.`,
      refinementLimit: 'Ya hemos afinado tres veces. Puedes quitar una preferencia o empezar de nuevo.',
      refinementUnrecognized: 'No hemos podido aplicar ese detalle al catálogo. Reformúlalo con color, forma, material, estilo, ajuste o presupuesto; también puedes pulsar “Ver otros modelos distintos”.',
      refinementNoResults: 'Ese cambio no ofrece una coincidencia fiable. Conservamos tus opciones anteriores para que puedas reformularlo.',
      refinementUpdated: count => count > 0 ? `Resultados actualizados con ${count} opciones nuevas.` : 'Resultados actualizados; el catálogo no ofrece más modelos distintos con esos criterios.',
      resultOne: 'Hemos seleccionado 1 opción para ti.',
      resultMany: count => `Hemos seleccionado ${count} opciones para ti.`,
      criteria: count => `Hemos tenido en cuenta ${count} preferencias.`,
      progress: (step, total) => `Pregunta ${step} de ${total}`,
      continue: 'Continuar',
      skip: 'No lo sé / Saltar',
      remove: label => `Quitar preferencia: ${label}`,
      recommended: 'Selección principal',
      good: 'Buena alternativa',
      why: 'Por qué te la recomendamos',
      consideration: 'A tener en cuenta',
      priceUnavailable: 'Precio no disponible',
      unavailable: 'Consultar disponibilidad',
      view: 'Ver detalles',
      compare: 'Comparar',
      viewProduct: title => `Ver ${title}`,
      compareProduct: title => `Comparar ${title}`,
      compareSummary: count => `${count} de ${MAX_COMPARE} monturas seleccionadas`,
      compareNeedMore: 'Selecciona al menos dos monturas para compararlas.',
      compareLimit: `Puedes comparar hasta ${MAX_COMPARE} monturas.`,
      removeCompare: title => `Quitar ${title} de la comparación`,
      comparisonCaption: 'Comparación de monturas seleccionadas',
      comparisonDifference: 'Diferencia clave',
      comparisonScroll: 'Comparación desplazable de las monturas seleccionadas',
      professionalHelp: 'Hablar con un óptico',
      feature: 'Característica',
      price: 'Precio',
      match: 'Coincidencia',
      alternatives: count => `Ver ${count} alternativas`,
      hideAlternatives: 'Ocultar alternativas',
      relaxed: values => `Para darte opciones, hemos flexibilizado: ${values}.`,
      noResults: 'No encontramos una coincidencia suficientemente fiable.',
      noResultsCopy: 'Puedes revisar una preferencia o explorar el catálogo completo.',
      handoffTitle: 'Necesitamos que te atienda un profesional',
      handoffDefault: 'Este tipo de consulta requiere valoración de un óptico u otro profesional sanitario.',
      currencyTitle: 'No podemos verificar ese presupuesto todavía',
      currencyDefault: 'Prueba con la moneda de la tienda o explora el catálogo para ver los precios disponibles.',
      refineHint: 'Elige una preferencia de “Lo que hemos entendido” para quitarla y responder de nuevo.',
      reset: 'Estamos listos para empezar de nuevo.',
      attributes: {
        availability: 'Disponibilidad', brand: 'Marca', bridge: 'Puente', color: 'Color',
        dimensions: 'Medidas', fit: 'Ajuste', frame: 'Montura', lens: 'Lente',
        lens_width: 'Ancho de lente', material: 'Material', shape: 'Forma',
        size: 'Talla', temple: 'Varilla', type: 'Tipo', weight: 'Peso'
      }
    },
    en: {
      loading: 'We’re reviewing the catalogue for you…',
      queryRequired: 'Tell us briefly what your ideal glasses would be like.',
      questionRequired: 'Choose an option or select “I’m not sure / Skip”.',
    questionRequiredChoice: 'Choose an option to continue.',
      retryQuery: 'We could not connect. Your description is still in the field so you can review and submit it again.',
      retryRefinement: 'We could not apply the refinement. Your detail is still in the field so you can review and submit it again.',
      retrySafe: 'The connection failed. You can retry without repeating your answers.',
      timeout: 'The response is taking longer than expected.',
      invalidResponse: 'The response did not contain usable recommendations.',
      guidedLoading: 'Let’s start with what matters most…',
      refining: 'Updating your preferences…',
      moreLoading: 'Finding models you have not seen yet…',
      moreOptions: 'Show different models',
      refinementRequired: 'Add one concrete detail to refine the options.',
      refinementHelp: 'You can specify colour, shape, brand, activity, lens, fit, or a budget with a number.',
      refinementProgress: (next, total) => `Refinement ${next} of ${total}`,
      refinementRemaining: remaining => remaining === 1 ? 'You will have one refinement left after this.' : `You will have ${remaining} refinements left after this.`,
      refinementLimit: 'We have refined three times. You can remove a preference or start again.',
      refinementUnrecognized: 'We could not apply that detail to the catalogue. Rephrase it with colour, shape, material, style, fit, or budget; you can also select “Show different models”.',
      refinementNoResults: 'That change has no reliable match. We kept your previous options so you can rephrase it.',
      refinementUpdated: count => count > 0 ? `Results updated with ${count} new options.` : 'Results updated; the catalogue has no more distinct models for those criteria.',
      resultOne: 'We selected 1 option for you.',
      resultMany: count => `We selected ${count} options for you.`,
      criteria: count => `We took ${count} preferences into account.`,
      progress: (step, total) => `Question ${step} of ${total}`,
      continue: 'Continue',
      skip: 'I’m not sure / Skip',
      remove: label => `Remove preference: ${label}`,
      recommended: 'Very strong match',
      good: 'Good alternative',
      why: 'Why we recommend it',
      consideration: 'Worth knowing',
      priceUnavailable: 'Price unavailable',
      unavailable: 'Check availability',
      view: 'View these frames',
      compare: 'Compare',
      viewProduct: title => `View ${title}`,
      compareProduct: title => `Compare ${title}`,
      compareSummary: count => `${count} of ${MAX_COMPARE} frames selected`,
      compareNeedMore: 'Select at least two frames to compare them.',
      compareLimit: `You can compare up to ${MAX_COMPARE} frames.`,
      removeCompare: title => `Remove ${title} from comparison`,
      comparisonCaption: 'Comparison of selected frames',
      comparisonDifference: 'Key difference',
      comparisonScroll: 'Scrollable comparison of selected frames',
      professionalHelp: 'Talk to an optician',
      feature: 'Feature',
      price: 'Price',
      match: 'Match',
      alternatives: count => `View ${count} alternatives`,
      hideAlternatives: 'Hide alternatives',
      relaxed: values => `To show useful options, we relaxed: ${values}.`,
      noResults: 'We could not find a sufficiently reliable match.',
      noResultsCopy: 'You can review a preference or browse the full catalogue.',
      handoffTitle: 'A professional should help with this request',
      handoffDefault: 'This type of question needs assessment by an optician or another healthcare professional.',
      currencyTitle: 'We cannot verify that budget yet',
      currencyDefault: 'Try the store currency or browse the catalogue to see the available prices.',
      refineHint: 'Choose a preference under “What we understood” to remove it and answer again.',
      reset: 'We’re ready to start again.',
      attributes: {
        availability: 'Availability', brand: 'Brand', bridge: 'Bridge', color: 'Colour',
        dimensions: 'Measurements', fit: 'Fit', frame: 'Frame', lens: 'Lens',
        lens_width: 'Lens width', material: 'Material', shape: 'Shape',
        size: 'Size', temple: 'Temple', type: 'Type', weight: 'Weight'
      }
    },
    fr: {
      loading: 'Nous parcourons le catalogue pour vous…',
      queryRequired: 'Décrivez brièvement les lunettes qui vous conviendraient le mieux.',
      questionRequired: 'Choisissez une option ou sélectionnez « Je ne sais pas / Passer ».',
    questionRequiredChoice: 'Choisissez une option pour continuer.',
      retryQuery: 'La connexion a échoué. Votre description reste dans le champ afin que vous puissiez la vérifier et la renvoyer.',
      retryRefinement: 'L’ajustement n’a pas pu être appliqué. Votre précision reste dans le champ afin que vous puissiez la vérifier et la renvoyer.',
      retrySafe: 'La connexion a échoué. Vous pouvez réessayer sans répéter vos réponses.',
      timeout: 'La réponse prend plus de temps que prévu.',
      invalidResponse: 'La réponse ne contient aucune recommandation utilisable.',
      guidedLoading: 'Commençons par l’essentiel…',
      refining: 'Mise à jour de vos préférences…',
      moreLoading: 'Recherche de modèles que vous n’avez pas encore vus…',
      moreOptions: 'Voir d’autres modèles',
      refinementRequired: 'Ajoutez un détail précis pour affiner les options.',
      refinementHelp: 'Vous pouvez préciser la couleur, la forme, la marque, l’activité, le verre, la taille ou un budget chiffré.',
      refinementProgress: (next, total) => `Ajustement ${next} sur ${total}`,
      refinementRemaining: remaining => remaining === 1 ? 'Il vous restera ensuite un ajustement.' : `Il vous restera ensuite ${remaining} ajustements.`,
      refinementLimit: 'Nous avons déjà affiné trois fois. Vous pouvez retirer une préférence ou recommencer.',
      refinementUnrecognized: 'Nous n’avons pas pu appliquer ce détail au catalogue. Reformulez-le avec une couleur, une forme, une matière, un style, un ajustement ou un budget ; vous pouvez aussi choisir « Voir d’autres modèles ».',
      refinementNoResults: 'Ce changement ne donne aucune correspondance fiable. Nous avons conservé vos options précédentes afin que vous puissiez le reformuler.',
      refinementUpdated: count => count > 0 ? `Résultats mis à jour avec ${count} nouvelles options.` : 'Résultats mis à jour ; le catalogue ne contient pas d’autres modèles distincts correspondant à ces critères.',
      resultOne: 'Nous avons sélectionné 1 option pour vous.',
      resultMany: count => `Nous avons sélectionné ${count} options pour vous.`,
      criteria: count => `Nous avons pris en compte ${count} préférences.`,
      progress: (step, total) => `Question ${step} sur ${total}`,
      continue: 'Continuer',
      skip: 'Je ne sais pas / Passer',
      remove: label => `Retirer la préférence : ${label}`,
      recommended: 'Très forte correspondance',
      good: 'Bonne alternative',
      why: 'Pourquoi nous la recommandons',
      consideration: 'À savoir',
      priceUnavailable: 'Prix indisponible',
      unavailable: 'Vérifier la disponibilité',
      view: 'Voir cette monture',
      compare: 'Comparer',
      viewProduct: title => `Voir ${title}`,
      compareProduct: title => `Comparer ${title}`,
      compareSummary: count => `${count} montures sélectionnées sur ${MAX_COMPARE}`,
      compareNeedMore: 'Sélectionnez au moins deux montures pour les comparer.',
      compareLimit: `Vous pouvez comparer jusqu’à ${MAX_COMPARE} montures.`,
      removeCompare: title => `Retirer ${title} de la comparaison`,
      comparisonCaption: 'Comparaison des montures sélectionnées',
      comparisonDifference: 'Différence clé',
      comparisonScroll: 'Comparaison défilante des montures sélectionnées',
      professionalHelp: 'Parler à un opticien',
      feature: 'Caractéristique',
      price: 'Prix',
      match: 'Correspondance',
      alternatives: count => `Voir ${count} alternatives`,
      hideAlternatives: 'Masquer les alternatives',
      relaxed: values => `Pour vous proposer des options, nous avons assoupli : ${values}.`,
      noResults: 'Nous n’avons pas trouvé de correspondance suffisamment fiable.',
      noResultsCopy: 'Vous pouvez modifier une préférence ou parcourir tout le catalogue.',
      handoffTitle: 'Un professionnel doit vous accompagner pour cette demande',
      handoffDefault: 'Ce type de demande nécessite l’avis d’un opticien ou d’un autre professionnel de santé.',
      currencyTitle: 'Nous ne pouvons pas encore vérifier ce budget',
      currencyDefault: 'Essayez la devise de la boutique ou parcourez le catalogue pour voir les prix disponibles.',
      refineHint: 'Sélectionnez une préférence dans « Ce que nous avons compris » pour la retirer et répondre de nouveau.',
      reset: 'Nous sommes prêts à recommencer.',
      attributes: {
        availability: 'Disponibilité', brand: 'Marque', bridge: 'Pont', color: 'Couleur',
        dimensions: 'Mesures', fit: 'Ajustement', frame: 'Monture', lens: 'Verre',
        lens_width: 'Largeur du verre', material: 'Matière', shape: 'Forme',
        size: 'Taille', temple: 'Branche', type: 'Type', weight: 'Poids'
      }
    },
    de: {
      loading: 'Wir durchsuchen den Katalog für Sie…',
      queryRequired: 'Beschreiben Sie kurz, wie Ihre ideale Brille aussehen soll.',
      questionRequired: 'Wählen Sie eine Option oder „Ich weiß es nicht / Überspringen“.',
    questionRequiredChoice: 'Wählen Sie eine Option, um fortzufahren.',
      retryQuery: 'Die Verbindung ist fehlgeschlagen. Ihre Beschreibung bleibt im Feld, damit Sie sie prüfen und erneut senden können.',
      retryRefinement: 'Die Anpassung konnte nicht übernommen werden. Ihre Angabe bleibt im Feld, damit Sie sie prüfen und erneut senden können.',
      retrySafe: 'Die Verbindung ist fehlgeschlagen. Sie können es erneut versuchen, ohne Ihre Antworten zu wiederholen.',
      timeout: 'Die Antwort dauert länger als erwartet.',
      invalidResponse: 'Die Antwort enthält keine nutzbaren Empfehlungen.',
      guidedLoading: 'Beginnen wir mit dem Wichtigsten…',
      refining: 'Ihre Präferenzen werden aktualisiert…',
      moreLoading: 'Wir suchen nach Modellen, die Sie noch nicht gesehen haben…',
      moreOptions: 'Andere Modelle anzeigen',
      refinementRequired: 'Ergänzen Sie ein konkretes Detail, um die Auswahl zu verfeinern.',
      refinementHelp: 'Sie können Farbe, Form, Marke, Sport, Gläser, Passform oder ein Budget als Zahl angeben.',
      refinementProgress: (next, total) => `Anpassung ${next} von ${total}`,
      refinementRemaining: remaining => remaining === 1 ? 'Danach bleibt noch eine Anpassung.' : `Danach bleiben noch ${remaining} Anpassungen.`,
      refinementLimit: 'Wir haben die Auswahl bereits dreimal verfeinert. Sie können eine Präferenz entfernen oder neu beginnen.',
      refinementUnrecognized: 'Dieses Detail konnte nicht auf den Katalog angewendet werden. Formulieren Sie es mit Farbe, Form, Material, Stil, Passform oder Budget neu; alternativ können Sie „Andere Modelle anzeigen“ wählen.',
      refinementNoResults: 'Für diese Änderung gibt es keine zuverlässige Übereinstimmung. Ihre vorherigen Optionen bleiben erhalten, damit Sie die Angabe neu formulieren können.',
      refinementUpdated: count => count > 0 ? `Ergebnisse mit ${count} neuen Optionen aktualisiert.` : 'Ergebnisse aktualisiert; für diese Kriterien bietet der Katalog keine weiteren unterschiedlichen Modelle.',
      resultOne: 'Wir haben 1 Option für Sie ausgewählt.',
      resultMany: count => `Wir haben ${count} Optionen für Sie ausgewählt.`,
      criteria: count => `Wir haben ${count} Präferenzen berücksichtigt.`,
      progress: (step, total) => `Frage ${step} von ${total}`,
      continue: 'Weiter',
      skip: 'Ich weiß es nicht / Überspringen',
      remove: label => `Präferenz entfernen: ${label}`,
      recommended: 'Sehr hohe Übereinstimmung',
      good: 'Gute Alternative',
      why: 'Warum wir sie empfehlen',
      consideration: 'Bitte beachten',
      priceUnavailable: 'Preis nicht verfügbar',
      unavailable: 'Verfügbarkeit prüfen',
      view: 'Diese Fassung ansehen',
      compare: 'Vergleichen',
      viewProduct: title => `${title} ansehen`,
      compareProduct: title => `${title} vergleichen`,
      compareSummary: count => `${count} von ${MAX_COMPARE} Fassungen ausgewählt`,
      compareNeedMore: 'Wählen Sie mindestens zwei Fassungen für den Vergleich aus.',
      compareLimit: `Sie können bis zu ${MAX_COMPARE} Fassungen vergleichen.`,
      removeCompare: title => `${title} aus dem Vergleich entfernen`,
      comparisonCaption: 'Vergleich der ausgewählten Fassungen',
      comparisonDifference: 'Wichtigster Unterschied',
      comparisonScroll: 'Seitlich scrollbarer Vergleich der ausgewählten Fassungen',
      professionalHelp: 'Mit einem Optiker sprechen',
      feature: 'Merkmal',
      price: 'Preis',
      match: 'Übereinstimmung',
      alternatives: count => `${count} Alternativen anzeigen`,
      hideAlternatives: 'Alternativen ausblenden',
      relaxed: values => `Um passende Optionen zu zeigen, haben wir folgende Kriterien gelockert: ${values}.`,
      noResults: 'Wir haben keine ausreichend zuverlässige Übereinstimmung gefunden.',
      noResultsCopy: 'Sie können eine Präferenz ändern oder den gesamten Katalog ansehen.',
      handoffTitle: 'Bei dieser Anfrage sollte Sie eine Fachperson unterstützen',
      handoffDefault: 'Diese Anfrage muss von einem Optiker oder einer anderen medizinischen Fachperson beurteilt werden.',
      currencyTitle: 'Dieses Budget kann noch nicht geprüft werden',
      currencyDefault: 'Versuchen Sie es mit der Shop-Währung oder sehen Sie sich die verfügbaren Preise im Katalog an.',
      refineHint: 'Wählen Sie unter „So haben wir Ihre Wünsche verstanden“ eine Präferenz aus, um sie zu entfernen und erneut zu antworten.',
      reset: 'Wir sind bereit, neu zu beginnen.',
      attributes: {
        availability: 'Verfügbarkeit', brand: 'Marke', bridge: 'Steg', color: 'Farbe',
        dimensions: 'Maße', fit: 'Passform', frame: 'Fassung', lens: 'Glas',
        lens_width: 'Glasbreite', material: 'Material', shape: 'Form',
        size: 'Größe', temple: 'Bügel', type: 'Typ', weight: 'Gewicht'
      }
    },
    ru: {
      loading: 'Мы просматриваем каталог для вас…',
      queryRequired: 'Кратко опишите, какими должны быть ваши идеальные очки.',
      questionRequired: 'Выберите вариант или нажмите «Не знаю / Пропустить».',
    questionRequiredChoice: 'Выберите вариант, чтобы продолжить.',
      retryQuery: 'Не удалось подключиться. Описание осталось в поле — проверьте его и отправьте снова.',
      retryRefinement: 'Не удалось применить уточнение. Оно осталось в поле — проверьте его и отправьте снова.',
      retrySafe: 'Ошибка соединения. Можно повторить попытку, не вводя ответы заново.',
      timeout: 'Ответ занимает больше времени, чем ожидалось.',
      invalidResponse: 'Ответ не содержит подходящих рекомендаций.',
      guidedLoading: 'Начнём с самого важного…',
      refining: 'Обновляем предпочтения…',
      moreLoading: 'Ищем модели, которые вы ещё не видели…',
      moreOptions: 'Показать другие модели',
      refinementRequired: 'Добавьте одну конкретную деталь, чтобы уточнить подбор.',
      refinementHelp: 'Можно указать цвет, форму, бренд, спорт, линзы, посадку или числовой бюджет.',
      refinementProgress: (next, total) => `Уточнение ${next} из ${total}`,
      refinementRemaining: remaining => remaining === 1 ? 'После этого останется ещё одно уточнение.' : `После этого останется уточнений: ${remaining}.`,
      refinementLimit: 'Подбор уже уточнялся три раза. Можно удалить предпочтение или начать заново.',
      refinementUnrecognized: 'Не удалось применить эту деталь к каталогу. Укажите цвет, форму, материал, стиль, посадку или бюджет другими словами; также можно выбрать «Показать другие модели».',
      refinementNoResults: 'Для этого изменения нет надёжного совпадения. Мы сохранили предыдущие варианты, чтобы вы могли переформулировать запрос.',
      refinementUpdated: count => count > 0 ? `Результаты обновлены: новых вариантов — ${count}.` : 'Результаты обновлены; в каталоге больше нет отличающихся моделей по этим критериям.',
      resultOne: 'Мы выбрали для вас 1 вариант.',
      resultMany: count => `Мы выбрали для вас ${count} вариантов.`,
      criteria: count => `Мы учли предпочтений: ${count}.`,
      progress: (step, total) => `Вопрос ${step} из ${total}`,
      continue: 'Продолжить',
      skip: 'Не знаю / Пропустить',
      remove: label => `Удалить предпочтение: ${label}`,
      recommended: 'Очень высокое совпадение',
      good: 'Хорошая альтернатива',
      why: 'Почему мы рекомендуем эту модель',
      consideration: 'Обратите внимание',
      priceUnavailable: 'Цена недоступна',
      unavailable: 'Уточнить наличие',
      view: 'Посмотреть эту оправу',
      compare: 'Сравнить',
      viewProduct: title => `Посмотреть ${title}`,
      compareProduct: title => `Сравнить ${title}`,
      compareSummary: count => `Выбрано оправ: ${count} из ${MAX_COMPARE}`,
      compareNeedMore: 'Для сравнения выберите не менее двух оправ.',
      compareLimit: `Можно сравнить не более ${MAX_COMPARE} оправ.`,
      removeCompare: title => `Удалить ${title} из сравнения`,
      comparisonCaption: 'Сравнение выбранных оправ',
      comparisonDifference: 'Ключевое отличие',
      comparisonScroll: 'Сравнение выбранных оправ с горизонтальной прокруткой',
      professionalHelp: 'Поговорить с оптиком',
      feature: 'Характеристика',
      price: 'Цена',
      match: 'Совпадение',
      alternatives: count => `Показать альтернативы: ${count}`,
      hideAlternatives: 'Скрыть альтернативы',
      relaxed: values => `Чтобы показать варианты, мы смягчили критерии: ${values}.`,
      noResults: 'Не найдено достаточно надёжного совпадения.',
      noResultsCopy: 'Измените одно из предпочтений или перейдите ко всему каталогу.',
      handoffTitle: 'С этим запросом должен помочь специалист',
      handoffDefault: 'Такой запрос требует оценки оптика или другого медицинского специалиста.',
      currencyTitle: 'Пока не удалось проверить этот бюджет',
      currencyDefault: 'Попробуйте валюту магазина или откройте каталог, чтобы увидеть доступные цены.',
      refineHint: 'Выберите предпочтение в разделе «Как мы поняли ваши пожелания», чтобы удалить его и ответить снова.',
      reset: 'Мы готовы начать подбор заново.',
      attributes: {
        availability: 'Наличие', brand: 'Бренд', bridge: 'Переносица', color: 'Цвет',
        dimensions: 'Размеры', fit: 'Посадка', frame: 'Оправа', lens: 'Линза',
        lens_width: 'Ширина линзы', material: 'Материал', shape: 'Форма',
        size: 'Размер', temple: 'Дужка', type: 'Тип', weight: 'Вес'
      }
    },
    zh: {
      loading: '我们正在为您浏览目录…',
      queryRequired: '请简要描述您理想中的眼镜。',
      questionRequired: '请选择一个选项，或选择“不确定 / 跳过”。',
    questionRequiredChoice: '请选择一个选项以继续。',
      retryQuery: '连接失败。您的描述仍保留在输入框中，可检查后再次提交。',
      retryRefinement: '未能应用本次调整。补充信息仍保留在输入框中，可检查后再次提交。',
      retrySafe: '连接失败。您可以直接重试，无需重复回答。',
      timeout: '响应时间比预期更长。',
      invalidResponse: '响应中没有可用的推荐。',
      guidedLoading: '让我们从最重要的开始…',
      refining: '正在更新您的偏好…',
      moreLoading: '正在寻找您尚未看过的款式…',
      moreOptions: '查看其他款式',
      refinementRequired: '请补充一个具体细节来优化推荐。',
      refinementHelp: '您可以说明颜色、形状、品牌、运动、镜片、尺寸或具体预算。',
      refinementProgress: (next, total) => `第 ${next}/${total} 次优化`,
      refinementRemaining: remaining => `之后还可优化 ${remaining} 次。`,
      refinementLimit: '我们已经优化了三次。您可以删除一项偏好或重新开始。',
      refinementUnrecognized: '无法将该细节应用到目录。请用颜色、形状、材质、风格、尺寸或预算重新描述；也可以选择“查看其他款式”。',
      refinementNoResults: '该调整没有可靠匹配。我们已保留之前的选项，您可以换一种方式描述。',
      refinementUpdated: count => count > 0 ? `结果已更新，新增 ${count} 个选项。` : '结果已更新；目录中没有更多符合这些条件的不同款式。',
      resultOne: '我们为您挑选了 1 个选项。',
      resultMany: count => `我们为您挑选了 ${count} 个选项。`,
      criteria: count => `我们考虑了 ${count} 项偏好。`,
      progress: (step, total) => `第 ${step}/${total} 个问题`,
      continue: '继续',
      skip: '不确定 / 跳过',
      remove: label => `删除偏好：${label}`,
      recommended: '高度匹配',
      good: '合适的替代选择',
      why: '为什么推荐这款',
      consideration: '请注意',
      priceUnavailable: '暂无价格',
      unavailable: '查询库存',
      view: '查看此镜架',
      compare: '对比',
      viewProduct: title => `查看${title}`,
      compareProduct: title => `对比${title}`,
      compareSummary: count => `已选择 ${count}/${MAX_COMPARE} 副镜架`,
      compareNeedMore: '请至少选择两副镜架进行对比。',
      compareLimit: `最多可对比 ${MAX_COMPARE} 副镜架。`,
      removeCompare: title => `从对比中删除${title}`,
      comparisonCaption: '已选镜架对比',
      comparisonDifference: '关键区别',
      comparisonScroll: '可横向滚动的已选镜架对比',
      professionalHelp: '咨询验光师',
      feature: '特征',
      price: '价格',
      match: '匹配度',
      alternatives: count => `查看 ${count} 个替代选择`,
      hideAlternatives: '隐藏替代选择',
      relaxed: values => `为提供更多选择，我们放宽了以下条件：${values}。`,
      noResults: '未找到足够可靠的匹配结果。',
      noResultsCopy: '您可以修改一项偏好，或浏览完整目录。',
      handoffTitle: '此需求需要专业人员协助',
      handoffDefault: '此类问题需要由验光师或其他医疗专业人员评估。',
      currencyTitle: '暂时无法核实该预算',
      currencyDefault: '请尝试使用商店货币，或浏览目录查看可用价格。',
      refineHint: '在“我们理解的需求”中选择一项偏好，将其删除后重新回答。',
      reset: '我们已准备好重新开始。',
      attributes: {
        availability: '库存', brand: '品牌', bridge: '鼻梁', color: '颜色',
        dimensions: '尺寸', fit: '佩戴尺寸', frame: '镜架', lens: '镜片',
        lens_width: '镜片宽度', material: '材质', shape: '形状',
        size: '尺码', temple: '镜腿', type: '类型', weight: '重量'
      }
    }
  };

  let instanceCount = 0;

  function cleanText(value, maxLength = 160) {
    if (typeof value !== 'string' && typeof value !== 'number') return '';
    return String(value).replace(/[\u0000-\u001f\u007f]/g, ' ').replace(/\s+/g, ' ').trim().slice(0, maxLength);
  }

  function looksPersonal(value) {
    const text = cleanText(value, 260);
    return EMAIL_LIKE.test(text) || PHONE_LIKE.test(text);
  }

  function safeKey(value) {
    const key = cleanText(value, 64);
    return /^[a-zA-Z][a-zA-Z0-9_-]{0,63}$/.test(key) ? key : '';
  }

  function safeSlug(value, fallback = '') {
    const slug = cleanText(value, 80).toLowerCase().replace(/[^a-z0-9_-]+/g, '_').replace(/^_+|_+$/g, '');
    return slug.slice(0, 80) || fallback;
  }

  function safeScalar(value) {
    if (value === null) return null;
    if (typeof value === 'boolean') return value;
    if (typeof value === 'number') return Number.isFinite(value) ? value : undefined;
    const text = cleanText(value, 80);
    if (!text || looksPersonal(text)) return undefined;
    return text;
  }

  function sanitizeAnswers(input) {
    const output = {};
    if (!input || typeof input !== 'object' || Array.isArray(input)) return output;
    for (const [rawKey, rawValue] of Object.entries(input).slice(0, 24)) {
      const key = safeKey(rawKey);
      if (!key || !ANSWER_FIELDS.has(key) || BLOCKED_STATE_KEY.test(key)) continue;
      if (Array.isArray(rawValue)) {
        const values = rawValue.slice(0, 8).map(safeScalar).filter(value => value !== undefined);
        if (values.length) output[key] = values;
        continue;
      }
      const value = safeScalar(rawValue);
      if (value !== undefined) output[key] = value;
    }
    return output;
  }

  function sanitizeSessionState(input, depth = 0, contextKey = '') {
    if (input === null || input === undefined || depth > 5) return null;
    if (typeof input === 'boolean') return input;
    if (typeof input === 'number') return Number.isFinite(input) ? input : null;
    if (typeof input === 'string') {
      const value = cleanText(input, 120);
      if (contextKey === 'shown_product_ids' && /^[A-Za-z0-9_-]{1,120}$/.test(value)) return value;
      return value && !looksPersonal(value) ? value : null;
    }
    if (Array.isArray(input)) {
      const limit = contextKey === 'shown_product_ids' ? MAX_TRACKED_RESULTS : 24;
      return input.slice(0, limit).map(value => sanitizeSessionState(value, depth + 1, contextKey)).filter(value => value !== null);
    }
    if (typeof input !== 'object') return null;
    const output = {};
    for (const [rawKey, rawValue] of Object.entries(input).slice(0, 32)) {
      const key = safeKey(rawKey);
      if (!key || BLOCKED_STATE_KEY.test(key)) continue;
      const value = sanitizeSessionState(rawValue, depth + 1, key);
      if (value !== null) output[key] = value;
    }
    return output;
  }

  function normalizeOption(option, index) {
    const source = option && typeof option === 'object' ? option : { value: option, label: option };
    const value = safeScalar(source.value ?? source.id ?? index);
    const label = cleanText(source.label ?? source.title ?? source.value, 100);
    if (value === undefined || !label) return null;
    return { value, label };
  }

  function normalizeQuestion(question) {
    if (!question || typeof question !== 'object') return null;
    const id = safeKey(question.id ?? question.key);
    const prompt = cleanText(question.prompt ?? question.label ?? question.question, 180);
    const options = (Array.isArray(question.options) ? question.options : [])
      .slice(0, 12)
      .map(normalizeOption)
      .filter(Boolean);
    if (!id || !ANSWER_FIELDS.has(id) || BLOCKED_STATE_KEY.test(id) || !prompt || options.length < 2) return null;
    const rawType = safeSlug(question.type, 'single');
    const multiple = ['multi', 'multiple', 'multiple_choice'].includes(rawType);
    const step = Number.isFinite(Number(question.step)) ? Math.max(1, Number(question.step)) : null;
    const total = Number.isFinite(Number(question.total)) ? Math.max(step || 1, Number(question.total)) : null;
    return {
      id,
      prompt,
      help: cleanText(question.help ?? question.description ?? question.why, 180),
      options,
      multiple,
      allowSkip: question.allow_skip === undefined ? question.required !== true : question.allow_skip !== false,
      step,
      total
    };
  }

  function normalizeInterpreted(interpreted) {
    if (!Array.isArray(interpreted)) return [];
    const seen = new Set();
    const output = [];
    for (const raw of interpreted.slice(0, 16)) {
      if (!raw || typeof raw !== 'object' || Array.isArray(raw)) continue;
      const key = safeKey(raw.key ?? raw.id).toLowerCase();
      const label = cleanText(raw.label ?? raw.display, 80);
      if (!SAFE_CRITERIA.has(key) || !label || looksPersonal(label) || seen.has(key)) continue;
      seen.add(key);
      output.push({ key, label, removable: raw.removable !== false });
    }
    return output;
  }

  function normalizeAttributes(attributes) {
    const output = {};
    if (!attributes || typeof attributes !== 'object' || Array.isArray(attributes)) return output;
    for (const [rawKey, rawValue] of Object.entries(attributes)) {
      const key = safeKey(rawKey).toLowerCase();
      const value = cleanText(Array.isArray(rawValue) ? rawValue.join(', ') : rawValue, 100);
      if (SAFE_ATTRIBUTES.has(key) && value) output[key] = value;
    }
    return output;
  }


  const CATALOGUE_LABELS = {"es":{"color":{"negro":"Negro","marron":"Marrón","azul":"Azul","rojo":"Rojo","verde":"Verde","rosa":"Rosa","blanco":"Blanco","gris":"Gris","dorado":"Dorado","plateado":"Plateado","transparente":"Transparente","carey":"Carey","burdeos":"Burdeos"},"material":{"acetato":"Acetato","titanio":"Titanio","plástico":"Plástico","inyectado":"Inyectado","aluminio":"Aluminio","acero":"Acero","carbono":"Carbono","metal":"Metal","propionato-de-celulosa":"Propionato de celulosa"},"shape":{"ojo-de-gato":"Ojo de gato","redonda":"Redonda","cuadrada":"Cuadrada","rectangular":"Rectangular","ovalada":"Ovalada","aviador":"Aviador","mariposa":"Mariposa","pantalla":"Pantalla","doble-puente":"Doble puente"},"type":{"Gafas de Sol":"Gafas de sol","Gafas Graduadas":"Gafas graduadas","Gafas Inteligentes":"Gafas inteligentes"},"lens":{"fotocromatico":"Fotocromático","luz-azul":"Luz azul","uniforme":"Uniforme","polarizado":"Polarizado","degradado":"Degradado","espejo":"Espejo"},"fit":{"pequena":"Estrecho","mediana":"Medio","grande":"Ancho"},"size":{"pequena":"Pequeña","mediana":"Mediana","grande":"Grande"},"availability":{"En stock":"En stock","Disponible":"Disponible","Agotado":"Agotado","Bajo pedido":"Bajo pedido","En fabricación":"En fabricación","En reserva":"En reserva"}},"en":{"color":{"negro":"Black","marron":"Brown","azul":"Blue","rojo":"Red","verde":"Green","rosa":"Pink","blanco":"White","gris":"Grey","dorado":"Gold","plateado":"Silver","transparente":"Clear","carey":"Tortoiseshell","burdeos":"Burgundy"},"material":{"acetato":"Acetate","titanio":"Titanium","plástico":"Plastic","inyectado":"Injected","aluminio":"Aluminium","acero":"Steel","carbono":"Carbon","metal":"Metal","propionato-de-celulosa":"Cellulose propionate"},"shape":{"ojo-de-gato":"Cat-eye","redonda":"Round","cuadrada":"Square","rectangular":"Rectangular","ovalada":"Oval","aviador":"Aviator","mariposa":"Butterfly","pantalla":"Shield","doble-puente":"Double bridge"},"type":{"Gafas de Sol":"Sunglasses","Gafas Graduadas":"Prescription glasses","Gafas Inteligentes":"Smart glasses"},"lens":{"polarizado":"Polarised","degradado":"Gradient","espejo":"Mirrored","uniforme":"Uniform","fotocromatico":"Photochromic","luz-azul":"Blue light"},"fit":{"pequena":"Narrow","mediana":"Medium","grande":"Wide"},"size":{"pequena":"Small","mediana":"Medium","grande":"Large"},"availability":{"En stock":"In stock","Disponible":"Available","Agotado":"Out of stock","Bajo pedido":"Available to order","En fabricación":"In production","En reserva":"Pre-order"}},"fr":{"color":{"negro":"Noir","marron":"Marron","azul":"Bleu","rojo":"Rouge","verde":"Vert","rosa":"Rose","blanco":"Blanc","gris":"Gris","dorado":"Doré","plateado":"Argenté","transparente":"Transparent","carey":"Écaille","havana":"Havane","burdeos":"Bordeaux"},"material":{"acetato":"Acétate","titanio":"Titane","metal":"Métal","plástico":"Plastique","inyectado":"Injecté","aluminio":"Aluminium","acero":"Acier","carbono":"Carbone","propionato-de-celulosa":"Propionate de cellulose"},"shape":{"ojo-de-gato":"Œil-de-chat","redonda":"Ronde","cuadrada":"Carrée","rectangular":"Rectangulaire","ovalada":"Ovale","aviador":"Aviateur","mariposa":"Papillon","pantalla":"Masque","doble-puente":"Double pont"},"type":{"Gafas de Sol":"Lunettes de soleil","Gafas Graduadas":"Lunettes de vue","Gafas Inteligentes":"Lunettes intelligentes"},"lens":{"polarizado":"Polarisé","degradado":"Dégradé","espejo":"Miroir","uniforme":"Uniforme","fotocromatico":"Photochromique","luz-azul":"Lumière bleue"},"fit":{"pequena":"Étroite","mediana":"Moyenne","grande":"Large"},"size":{"pequena":"Petite","mediana":"Moyenne","grande":"Grande"},"availability":{"En stock":"En stock","Disponible":"Disponible","Agotado":"Épuisé","Bajo pedido":"Sur commande","En fabricación":"En fabrication","En reserva":"Précommande"}},"de":{"color":{"negro":"Schwarz","marron":"Braun","azul":"Blau","rojo":"Rot","verde":"Grün","rosa":"Rosa","blanco":"Weiß","gris":"Grau","dorado":"Gold","plateado":"Silber","transparente":"Transparent","carey":"Schildpatt","havana":"Havanna","burdeos":"Bordeaux"},"material":{"acetato":"Acetat","titanio":"Titan","metal":"Metall","plástico":"Kunststoff","inyectado":"Spritzguss","aluminio":"Aluminium","acero":"Stahl","carbono":"Carbon","propionato-de-celulosa":"Cellulosepropionat"},"shape":{"ojo-de-gato":"Katzenauge","redonda":"Rund","cuadrada":"Quadratisch","rectangular":"Rechteckig","ovalada":"Oval","aviador":"Pilotenform","mariposa":"Schmetterlingsform","pantalla":"Maskenform","doble-puente":"Doppelsteg"},"type":{"Gafas de Sol":"Sonnenbrille","Gafas Graduadas":"Korrektionsbrille","Gafas Inteligentes":"Smartbrille"},"lens":{"polarizado":"Polarisiert","degradado":"Verlauf","espejo":"Verspiegelt","uniforme":"Einfarbig","fotocromatico":"Photochrom","luz-azul":"Blaulicht"},"fit":{"pequena":"Schmal","mediana":"Mittel","grande":"Breit"},"size":{"pequena":"Klein","mediana":"Mittel","grande":"Groß"},"availability":{"En stock":"Auf Lager","Disponible":"Verfügbar","Agotado":"Ausverkauft","Bajo pedido":"Auf Bestellung","En fabricación":"In Produktion","En reserva":"Vorbestellung"}},"ru":{"color":{"negro":"Чёрный","marron":"Коричневый","azul":"Синий","rojo":"Красный","verde":"Зелёный","rosa":"Розовый","blanco":"Белый","gris":"Серый","dorado":"Золотой","plateado":"Серебристый","transparente":"Прозрачный","carey":"Черепаховый","havana":"Гавана","burdeos":"Бордовый"},"material":{"acetato":"Ацетат","titanio":"Титан","metal":"Металл","plástico":"Пластик","inyectado":"Литьевой пластик","aluminio":"Алюминий","acero":"Сталь","carbono":"Карбон","propionato-de-celulosa":"Пропионат целлюлозы"},"shape":{"ojo-de-gato":"Кошачий глаз","redonda":"Круглая","cuadrada":"Квадратная","rectangular":"Прямоугольная","ovalada":"Овальная","aviador":"Авиатор","mariposa":"Бабочка","pantalla":"Маска","doble-puente":"Двойная переносица"},"type":{"Gafas de Sol":"Солнцезащитные очки","Gafas Graduadas":"Оптические очки","Gafas Inteligentes":"Умные очки"},"lens":{"polarizado":"Поляризованные","degradado":"Градиентные","espejo":"Зеркальные","uniforme":"Однотонные","fotocromatico":"Фотохромные","luz-azul":"Синий свет"},"fit":{"pequena":"Узкая","mediana":"Средняя","grande":"Широкая"},"size":{"pequena":"Маленький","mediana":"Средний","grande":"Большой"},"availability":{"En stock":"В наличии","Disponible":"Доступно","Agotado":"Нет в наличии","Bajo pedido":"Под заказ","En fabricación":"В производстве","En reserva":"Предзаказ"}},"zh":{"color":{"negro":"黑色","marron":"棕色","azul":"蓝色","rojo":"红色","verde":"绿色","rosa":"粉色","blanco":"白色","gris":"灰色","dorado":"金色","plateado":"银色","transparente":"透明色","carey":"玳瑁色","havana":"哈瓦那色","burdeos":"酒红色"},"material":{"acetato":"醋酸纤维","titanio":"钛","metal":"金属","plástico":"塑料","inyectado":"注塑","aluminio":"铝","acero":"钢","carbono":"碳纤维","propionato-de-celulosa":"丙酸纤维素"},"shape":{"ojo-de-gato":"猫眼形","redonda":"圆形","cuadrada":"方形","rectangular":"矩形","ovalada":"椭圆形","aviador":"飞行员款","mariposa":"蝴蝶形","pantalla":"面罩形","doble-puente":"双鼻梁"},"type":{"Gafas de Sol":"太阳镜","Gafas Graduadas":"光学眼镜","Gafas Inteligentes":"智能眼镜"},"lens":{"polarizado":"偏光","degradado":"渐变","espejo":"镜面","uniforme":"纯色","fotocromatico":"变色","luz-azul":"防蓝光"},"fit":{"pequena":"窄版","mediana":"标准版","grande":"宽版"},"size":{"pequena":"小号","mediana":"中号","grande":"大号"},"availability":{"En stock":"现货","Disponible":"可订购","Agotado":"缺货","Bajo pedido":"按订单订购","En fabricación":"生产中","En reserva":"预订"}}};

  function catalogueLabelKey(value) {
    return String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[ _]+/g, '-').trim();
  }

  function localizedAttributeValue(field, value, locale) {
    const original = cleanText(value, 100);
    if (!original) return '';
    const labels = (CATALOGUE_LABELS[primaryLocale(locale)] || CATALOGUE_LABELS.es)[field];
    if (!labels) return original;
    const values = new Map(Object.entries(labels).map(([key, label]) => [catalogueLabelKey(key), label]));
    return original.split(/,\s*/).map(part => values.get(catalogueLabelKey(part)) || part).join(', ');
  }

  function productIdentity(product) {
    const original = cleanText(product.title, 140);
    const brand = cleanText(product.brand, 80);
    if (/^chanel$/i.test(brand)) return { model: original, name: original };
    let model = original.replace(/^(?:gafas\s+(?:de\s+sol|graduadas|inteligentes|deportivas)|sunglasses|prescription\s+(?:glasses|frames)|smart\s+glasses)\s+/i, '');
    if (brand) {
      const prefix = brand.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      model = model.replace(new RegExp('^' + prefix + '(?:\\s+|\\s*[|:]\\s*)', 'i'), '').trim();
    }
    if (!model) return { model: original, name: original };
    return { model, name: brand && model !== original ? brand + ' ' + model : original };
  }

  function normalizePrice(rawPrice, fallbackCurrency) {
    const source = rawPrice && typeof rawPrice === 'object' ? rawPrice : { amount: rawPrice };
    const amount = Number(source.amount ?? source.value);
    if (!Number.isFinite(amount) || amount < 0) return null;
    const currencyCandidate = cleanText(source.currency ?? source.currency_code ?? fallbackCurrency, 3).toUpperCase();
    const currency = /^[A-Z]{3}$/.test(currencyCandidate) ? currencyCandidate : 'EUR';
    return { amount, currency };
  }

  function normalizeProduct(product, index, fallbackCurrency) {
    if (!product || typeof product !== 'object') return null;
    const envelope = product;
    const source = product.product && typeof product.product === 'object' ? product.product : product;
    const title = cleanText(source.title ?? source.name, 140);
    const rawUrl = cleanText(source.pdp_url ?? source.url, 500);
    const id = cleanText(source.id ?? source.product_id ?? source.handle ?? rawUrl ?? index, 120);
    if (!id || !title || !rawUrl) return null;
    const imageSource = source.image && typeof source.image === 'object'
      ? source.image
      : { url: source.image_url, alt: source.image_alt };
    const matchTierCandidate = safeSlug(envelope.match_level ?? source.match_tier ?? source.match, 'good');
    const matchTier = ['very_high', 'high', 'good', 'alternative', 'price'].includes(matchTierCandidate)
      ? matchTierCandidate
      : 'good';
    const reasons = (Array.isArray(envelope.reasons) ? envelope.reasons : Array.isArray(source.reasons) ? source.reasons : [])
      .slice(0, 4)
      .map(value => cleanText(value, 180))
      .filter(Boolean);
    const tradeoffSource = Array.isArray(envelope.considerations)
      ? envelope.considerations
      : Array.isArray(source.tradeoffs) ? source.tradeoffs : source.tradeoff ? [source.tradeoff] : [];
    const tradeoffs = tradeoffSource
      .slice(0, 2)
      .map(value => cleanText(value, 160))
      .filter(Boolean);
    const attributesSource = source.attributes ?? source.facts ?? {
      availability: source.in_stock === true ? 'En stock' : source.available === true ? 'Disponible' : '',
      type: source.product_type,
      color: source.colors,
      material: source.materials,
      shape: source.shapes,
      size: source.sizes
    };
    const priceSource = source.price ?? (source.min_price !== undefined
      ? { amount: source.min_price, currency: source.currency ?? fallbackCurrency }
      : null);
    return {
      id,
      title,
      brand: cleanText(source.brand ?? source.vendor, 80),
      rawUrl,
      imageUrl: cleanText(imageSource.url ?? imageSource.src, 600),
      imageAlt: cleanText(imageSource.alt, 140),
      price: normalizePrice(priceSource, fallbackCurrency),
      available: source.available !== false && source.in_stock !== false,
      matchTier,
      reasons,
      tradeoffs,
      attributes: normalizeAttributes(attributesSource)
    };
  }

  function normalizeMeta(meta) {
    const source = meta && typeof meta === 'object' ? meta : {};
    const relaxedSource = Array.isArray(source.relaxed_criteria)
      ? source.relaxed_criteria
      : Array.isArray(source.constraints_relaxed) ? source.constraints_relaxed : [];
    const relaxed = relaxedSource
      .slice(0, 4)
      .map(value => cleanText(value, 60))
      .filter(value => value && !looksPersonal(value));
    return {
      notice: cleanText(source.notice, 200),
      status: safeSlug(source.status),
      handoffMessage: cleanText(source.handoff && source.handoff.message, 240),
      handoffCode: safeSlug(source.handoff && source.handoff.code),
      fallback: source.fallback === true,
      relaxed,
      criteriaCount: Number.isFinite(Number(source.criteria_count)) ? Math.max(0, Number(source.criteria_count)) : null,
      resultCount: Number.isFinite(Number(source.result_count)) ? Math.max(0, Number(source.result_count)) : null,
      canRefine: source.can_refine === true,
      refinementRound: Number.isFinite(Number(source.refinement_round)) ? Math.max(0, Math.min(MAX_REFINEMENTS, Number(source.refinement_round))) : 0,
      refinementLimit: Number.isFinite(Number(source.refinement_limit)) ? Math.max(1, Math.min(MAX_REFINEMENTS, Number(source.refinement_limit))) : MAX_REFINEMENTS,
      refinementsRemaining: Number.isFinite(Number(source.refinements_remaining)) ? Math.max(0, Math.min(MAX_REFINEMENTS, Number(source.refinements_remaining))) : MAX_REFINEMENTS,
      newResultCount: Number.isFinite(Number(source.new_result_count)) ? Math.max(0, Number(source.new_result_count)) : 0,
      repeatedCount: Number.isFinite(Number(source.repeated_count)) ? Math.max(0, Number(source.repeated_count)) : 0
    };
  }

  function normalizeResponse(payload, fallbackCurrency = 'EUR') {
    if (!payload || typeof payload !== 'object' || Array.isArray(payload)) throw new TypeError('invalid_response');
    const hasContractShape = Object.prototype.hasOwnProperty.call(payload, 'question')
      || Array.isArray(payload.recommendations)
      || Array.isArray(payload.alternatives);
    if (!hasContractShape) throw new TypeError('invalid_response');
    const primaryRaw = Array.isArray(payload.recommendations) ? payload.recommendations : [];
    const alternativesRaw = Array.isArray(payload.alternatives) ? payload.alternatives : [];
    let recommendations = primaryRaw.map((product, index) => normalizeProduct(product, index, fallbackCurrency)).filter(Boolean);
    let alternatives = alternativesRaw.map((product, index) => normalizeProduct(product, index + 100, fallbackCurrency)).filter(Boolean);
    alternatives = recommendations.slice(3).concat(alternatives);
    recommendations = recommendations.slice(0, 3);
    if (!recommendations.length && alternatives.length) {
      recommendations = alternatives.slice(0, 3);
      alternatives = alternatives.slice(3);
    }
    const seen = new Set(recommendations.map(product => product.id));
    alternatives = alternatives.filter(product => {
      if (seen.has(product.id)) return false;
      seen.add(product.id);
      return true;
    }).slice(0, 12);
    return {
      sessionState: sanitizeSessionState(payload.session_state),
      interpreted: normalizeInterpreted(payload.interpreted),
      question: normalizeQuestion(payload.question),
      recommendations,
      alternatives,
      meta: normalizeMeta(payload.meta)
    };
  }

  async function fetchWithNetworkRetry(fetcher, endpoint, options) {
    try {
      return await fetcher(endpoint, options);
    } catch (error) {
      if ((options && options.signal && options.signal.aborted) || (error && error.name === 'AbortError')) {
        throw error;
      }
      // Recommendation requests are read-only and deterministic. One immediate
      // retry absorbs transient CORS/TLS connection races without retaining the
      // shopper's phrase beyond this in-flight request.
      return fetcher(endpoint, options);
    }
  }

  function buildPayload({ query = '', locale = 'es', mode = 'free', country = '', currency = 'EUR', answers = {}, sessionState = null, includeQuery = false, action = 'start' } = {}) {
    const normalizedCountry = cleanText(country, 2).toUpperCase();
    const normalizedCurrency = cleanText(currency, 3).toUpperCase();
    return {
      query: includeQuery ? cleanText(query, MAX_QUERY_LENGTH) : '',
      locale: primaryLocale(locale),
      mode: mode === 'guided' ? 'guided' : 'free',
      ...(normalizedCountry ? { country: /^[A-Z]{2}$/.test(normalizedCountry) ? normalizedCountry : undefined } : {}),
      currency: /^[A-Z]{3}$/.test(normalizedCurrency) ? normalizedCurrency : 'EUR',
      answers: sanitizeAnswers(answers),
      session_state: sanitizeSessionState(sessionState),
      action: ['start', 'answer', 'refine', 'more'].includes(action) ? action : 'start'
    };
  }

  function sanitizeAnalytics(action, details = {}) {
    if (!ANALYTICS_ACTIONS.has(action)) return null;
    const event = { event: 'oh_advisor', advisor_action: action, advisor_version: VERSION };
    if (!details || typeof details !== 'object') return event;
    for (const [key, rawValue] of Object.entries(details)) {
      if (!ANALYTICS_FIELDS.has(key)) continue;
      if (typeof rawValue === 'number' && Number.isFinite(rawValue)) {
        event[`advisor_${key}`] = rawValue;
      } else if (typeof rawValue === 'boolean') {
        event[`advisor_${key}`] = rawValue;
      } else {
        const value = safeSlug(rawValue);
        if (value) event[`advisor_${key}`] = value;
      }
    }
    return event;
  }

  function updateComparison(currentIds, productId, selected, max = MAX_COMPARE) {
    const ids = Array.isArray(currentIds) ? currentIds.slice(0, max) : [];
    const id = cleanText(productId, 120);
    if (!id) return { ids, accepted: false };
    const without = ids.filter(item => item !== id);
    if (!selected) return { ids: without, accepted: true };
    if (ids.includes(id)) return { ids, accepted: true };
    if (ids.length >= max) return { ids, accepted: false };
    return { ids: ids.concat(id), accepted: true };
  }

  function primaryLocale(locale) {
    const normalized = cleanText(locale, 12).replace(/_/g, '-').slice(0, 2).toLowerCase();
    return SUPPORTED_LOCALES.has(normalized) ? normalized : 'es';
  }

  function normalizeStoreRoot(rawRoot, baseUrl) {
    try {
      const base = new URL(baseUrl || 'https://opticalh.example/');
      const root = new URL(cleanText(rawRoot, 300) || '/', base);
      if (!['http:', 'https:'].includes(root.protocol) || root.origin !== base.origin) return '/';
      let pathname = root.pathname.replace(/\/{2,}/g, '/');
      if (!pathname.startsWith('/')) pathname = `/${pathname}`;
      if (!pathname.endsWith('/')) pathname = `${pathname}/`;
      return pathname;
    } catch (_) {
      return '/';
    }
  }

  function normalizeEndpoint(rawEndpoint, baseUrl) {
    const fallback = '/v1/advisor/recommend';
    const endpoint = cleanText(rawEndpoint, 500);
    if (!endpoint) return fallback;
    if (/^\/(?!\/)/.test(endpoint)) return endpoint;
    if (!/^https:\/\//i.test(endpoint)) return fallback;
    try {
      const url = new URL(endpoint, baseUrl || 'https://opticalh.example/');
      return url.protocol === 'https:' ? url.toString() : fallback;
    } catch (_) {
      return fallback;
    }
  }

  function advisorProductUrl(rawUrl, baseUrl, rootUrl) {
    try {
      const base = new URL(baseUrl || 'https://opticalh.example/');
      const url = new URL(rawUrl, base);
      if (!['http:', 'https:'].includes(url.protocol)) return '';
      if (url.origin === base.origin && rootUrl !== undefined && rootUrl !== null) {
        const productMarker = '/products/';
        const markerIndex = url.pathname.indexOf(productMarker);
        if (markerIndex >= 0) {
          const productPath = url.pathname.slice(markerIndex + 1);
          url.pathname = `${normalizeStoreRoot(rootUrl, base)}${productPath}`.replace(/\/{2,}/g, '/');
        }
      }
      url.searchParams.set('oh_advisor', '1');
      return url.origin === base.origin ? `${url.pathname}${url.search}${url.hash}` : url.toString();
    } catch (_) {
      return '';
    }
  }

  function advisorHelpUrl(rawUrl, baseUrl, rootUrl) {
    const fallback = `${normalizeStoreRoot(rootUrl, baseUrl)}pages/contact`;
    const configured = cleanText(rawUrl, 500);
    if (!configured) return fallback;
    try {
      const base = new URL(baseUrl || 'https://opticalh.example/');
      const url = new URL(configured, base);
      if (!['http:', 'https:'].includes(url.protocol)) return fallback;
      if (url.origin === base.origin) return `${url.pathname}${url.search}${url.hash}`;
      return url.protocol === 'https:' ? url.toString() : fallback;
    } catch (_) {
      return fallback;
    }
  }

  function advisorEntrySource(rawUrl) {
    try {
      const url = new URL(rawUrl || '', 'https://opticalh.example/');
      const value = safeSlug(url.searchParams.get('oh_entry'));
      return ENTRY_SOURCES.has(value) ? value : 'direct';
    } catch (_) {
      return 'direct';
    }
  }

  function safeImageUrl(rawUrl, baseUrl) {
    if (!cleanText(rawUrl, 600)) return '';
    try {
      const url = new URL(rawUrl, baseUrl || 'https://opticalh.example/');
      return ['http:', 'https:'].includes(url.protocol) ? url.toString() : '';
    } catch (_) {
      return '';
    }
  }

  function copyFor(locale) {
    return COPY[primaryLocale(locale)];
  }

  function formatPrice(price, locale, copy) {
    if (!price) return copy.priceUnavailable;
    try {
      return new Intl.NumberFormat(locale || 'es-ES', { style: 'currency', currency: price.currency }).format(price.amount);
    } catch (_) {
      return `${price.amount.toFixed(2)} ${price.currency}`;
    }
  }

  function createNode(documentRef, tag, className, text) {
    const element = documentRef.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined && text !== null) element.textContent = String(text);
    return element;
  }

  const testApi = {
    MAX_COMPARE,
    MAX_REFINEMENTS,
    MAX_TRACKED_RESULTS,
    SUPPORTED_LOCALES,
    advisorHelpUrl,
    advisorEntrySource,
    advisorProductUrl,
    buildPayload,
    copyFor,
    fetchWithNetworkRetry,
    normalizeEndpoint,
    normalizeInterpreted,
    normalizeQuestion,
    normalizeResponse,
    localizedAttributeValue,
    productIdentity,
    normalizeStoreRoot,
    primaryLocale,
    sanitizeAnalytics,
    sanitizeAnswers,
    sanitizeSessionState,
    updateComparison
  };

  if (scope && scope.__OH_ADVISOR_TEST__) scope.__OH_ADVISOR_TEST_API__ = testApi;
  if (!scope || !scope.HTMLElement || !scope.customElements || !scope.document) return;

  class OHGlassesAdvisor extends scope.HTMLElement {
    constructor() {
      super();
      this.instanceId = `oha-${++instanceCount}`;
      this.state = this.freshState();
      this.requestController = null;
      this.requestSequence = 0;
      this.timeoutId = null;
      this.lastRequestWasSafe = false;
      this.lastSafeRequest = null;
      this.lastRequestAction = 'start';
      this.boundSubmit = event => this.onSubmit(event);
      this.boundClick = event => this.onClick(event);
      this.boundChange = event => this.onChange(event);
      this.boundInput = event => this.onInput(event);
      this.boundKeydown = event => this.onKeydown(event);
    }

    freshState() {
      return {
        mode: 'free',
        answers: {},
        sessionState: null,
        interpreted: [],
        question: null,
        recommendations: [],
        alternatives: [],
        meta: {},
        refinementOpen: false,
        refinementError: '',
        refinementRound: 0,
        refinementLimit: MAX_REFINEMENTS,
        compared: [],
        products: new Map(),
        impressions: new Set(),
        compareOpen: false,
        alternativesOpen: false
      };
    }

    connectedCallback() {
      if (this.dataset.ohReady === 'true') return;
      this.dataset.ohReady = 'true';
      this.locale = primaryLocale(this.dataset.locale);
      this.country = cleanText(this.dataset.country, 2).toUpperCase();
      this.currency = cleanText(this.dataset.currency, 3).toUpperCase() || 'EUR';
      const currentUrl = scope.location && scope.location.href;
      this.entrySource = advisorEntrySource(currentUrl);
      const shopifyRoot = scope.Shopify && scope.Shopify.routes && scope.Shopify.routes.root;
      this.rootUrl = normalizeStoreRoot(this.dataset.rootUrl || shopifyRoot || '/', currentUrl);
      this.endpoint = normalizeEndpoint(this.dataset.endpoint, currentUrl);
      this.fallbackUrl = cleanText(this.dataset.fallbackUrl, 500) || '/search';
      this.helpUrl = advisorHelpUrl(this.dataset.helpUrl, currentUrl, this.rootUrl);
      this.requestTimeout = Math.min(30000, Math.max(3000, Number(this.dataset.requestTimeout) || 12000));
      this.copy = copyFor(this.locale);
      this.cacheReferences();
      if (this.refs.help) {
        this.refs.help.href = this.helpUrl;
        this.refs.help.textContent = this.copy.professionalHelp;
      }
      this.assignUniqueIds();
      this.addEventListener('submit', this.boundSubmit);
      this.addEventListener('click', this.boundClick);
      this.addEventListener('change', this.boundChange);
      this.addEventListener('input', this.boundInput);
      this.addEventListener('keydown', this.boundKeydown);
      this.refs.questionSubmit.textContent = this.copy.continue;
      this.refs.questionSkip.textContent = this.copy.skip;
      this.renderInitial();
      this.track('advisor_open', { mode: 'free', stage: 'entry' });
    }

    disconnectedCallback() {
      this.requestSequence += 1;
      if (this.requestController) this.requestController.abort();
      if (this.timeoutId) scope.clearTimeout(this.timeoutId);
    }

    cacheReferences() {
      const find = selector => this.querySelector(selector);
      const queryForm = find('[data-oh-query-form]');
      let queryError = find('[data-oh-query-error]');
      if (!queryError && queryForm) {
        queryError = createNode(scope.document, 'p', 'oha-field-error oha-query__error');
        queryError.dataset.ohQueryError = '';
        queryError.setAttribute('role', 'alert');
        queryError.hidden = true;
        queryForm.append(queryError);
      }
      this.refs = {
        title: find('[data-oh-title]'),
        mode: find('.oha-mode'),
        entry: find('[data-oh-entry]'),
        queryForm,
        query: find('[data-oh-query]'),
        queryError,
        guided: find('[data-oh-guided]'),
        guidedStart: find('[data-oh-guided-start]'),
        status: find('[data-oh-status]'),
        loading: find('[data-oh-loading]'),
        error: find('[data-oh-error]'),
        errorCopy: find('[data-oh-error-copy]'),
        retry: find('[data-oh-retry]'),
        interpreted: find('[data-oh-interpreted]'),
        chips: find('[data-oh-chips]'),
        question: find('[data-oh-question]'),
        questionForm: find('[data-oh-question-form]'),
        questionTitle: find('[data-oh-question-title]'),
        questionHelp: find('[data-oh-question-help]'),
        questionOptions: find('[data-oh-question-options]'),
        questionSubmit: find('[data-oh-question-submit]'),
        questionSkip: find('[data-oh-question-skip]'),
        progress: find('[data-oh-progress]'),
        fieldError: find('[data-oh-field-error]'),
        results: find('[data-oh-results]'),
        resultsTitle: find('[data-oh-results-title]'),
        resultSummary: find('[data-oh-result-summary]'),
        notice: find('[data-oh-notice]'),
        recommendations: find('[data-oh-recommendations]'),
        alternatives: find('[data-oh-alternatives]'),
        alternativesToggle: find('[data-oh-alternatives-toggle]'),
        alternativesList: find('[data-oh-alternatives-list]'),
        refinement: find('[data-oh-refinement]'),
        refinementTitle: find('[data-oh-refinement-title]'),
        refinementProgress: find('[data-oh-refinement-progress]'),
        refinementForm: find('[data-oh-refinement-form]'),
        refinementQuery: find('[data-oh-refinement-query]'),
        refinementHelp: find('[data-oh-refinement-help]'),
        refinementError: find('[data-oh-refinement-error]'),
        refinementLimit: find('[data-oh-refinement-limit]'),
        compareTray: find('[data-oh-compare-tray]'),
        compareSummary: find('[data-oh-compare-summary]'),
        compareOpen: find('[data-oh-compare-open]'),
        compare: find('[data-oh-compare]'),
        compareTitle: find('[data-oh-compare-title]'),
        compareContent: find('[data-oh-compare-content]'),
        empty: find('[data-oh-empty]'),
        emptyTitle: find('[data-oh-empty-title]'),
        emptyCopy: find('[data-oh-empty-copy]'),
        help: find('[data-oh-help-link]'),
        reset: find('[data-oh-reset]')
      };
    }

    assignUniqueIds() {
      const privacy = this.querySelector('.oha-privacy');
      const guidedTitle = this.refs.guided && this.refs.guided.querySelector('[data-oh-guided-title], h2, h3');
      const understoodTitle = this.refs.interpreted && this.refs.interpreted.querySelector('[data-oh-interpreted-title], h2, h3');
      const queryLabel = this.refs.queryForm && this.refs.queryForm.querySelector('label');
      const idMap = [
        [this.refs.title, 'title'], [privacy, 'privacy'], [this.refs.status, 'status'],
        [guidedTitle, 'guided-title'], [understoodTitle, 'understood-title'],
        [this.refs.queryError, 'query-error'],
        [this.refs.questionTitle, 'question-title'], [this.refs.resultsTitle, 'results-title'],
        [this.refs.refinement, 'refinement'],
        [this.refs.refinementTitle, 'refinement-title'], [this.refs.refinementQuery, 'refinement-query'],
        [this.refs.refinementHelp, 'refinement-help'], [this.refs.refinementError, 'refinement-error'],
        [this.refs.alternativesList, 'alternatives'], [this.refs.compareTitle, 'compare-title'],
        [this.refs.query, 'query']
      ];
      for (const [element, suffix] of idMap) if (element) element.id = `${this.instanceId}-${suffix}`;
      this.setAttribute('aria-labelledby', this.refs.title.id);
      if (queryLabel) queryLabel.htmlFor = this.refs.query.id;
      this.refs.query.setAttribute(
        'aria-describedby',
        [privacy && privacy.id, this.refs.queryError && this.refs.queryError.id, this.refs.status.id].filter(Boolean).join(' ')
      );
      if (guidedTitle) this.refs.guided.setAttribute('aria-labelledby', guidedTitle.id);
      if (understoodTitle) this.refs.interpreted.setAttribute('aria-labelledby', understoodTitle.id);
      this.refs.question.setAttribute('aria-labelledby', this.refs.questionTitle.id);
      this.refs.results.setAttribute('aria-labelledby', this.refs.resultsTitle.id);
      this.refs.refinement.setAttribute('aria-labelledby', this.refs.refinementTitle.id);
      const refinementLabel = this.refs.refinementForm.querySelector('label');
      if (refinementLabel) refinementLabel.htmlFor = this.refs.refinementQuery.id;
      this.refs.refinementQuery.setAttribute(
        'aria-describedby',
        [this.refs.refinementHelp.id, this.refs.refinementError.id].filter(Boolean).join(' ')
      );
      for (const trigger of this.querySelectorAll('[data-oh-refine]')) {
        trigger.setAttribute('aria-controls', this.refs.refinement.id || `${this.instanceId}-refinement`);
      }
      this.refs.alternativesToggle.setAttribute('aria-controls', this.refs.alternativesList.id);
      this.refs.compare.setAttribute('aria-labelledby', this.refs.compareTitle.id);
    }

    renderInitial() {
      this.refs.loading.hidden = true;
      this.refs.mode.hidden = false;
      this.refs.entry.hidden = false;
      this.refs.error.hidden = true;
      this.refs.interpreted.hidden = true;
      this.refs.question.hidden = true;
      this.refs.results.hidden = true;
      this.refs.alternatives.hidden = true;
      this.refs.refinement.hidden = true;
      this.refs.refinementForm.hidden = true;
      this.refs.refinementError.hidden = true;
      this.refs.refinementLimit.hidden = true;
      this.refs.compareTray.hidden = true;
      this.refs.compare.hidden = true;
      this.refs.empty.hidden = true;
      this.refs.empty.querySelector('[data-oh-refine]').hidden = false;
      this.refs.emptyTitle.textContent = this.copy.noResults;
      this.refs.emptyCopy.textContent = this.copy.noResultsCopy;
      this.refs.reset.hidden = true;
      this.refs.query.value = '';
      this.refs.query.removeAttribute('aria-invalid');
      this.refs.queryError.textContent = '';
      this.refs.queryError.hidden = true;
      this.refs.refinementQuery.value = '';
      this.switchMode('free', false);
      this.setBusy(false);
    }

    onSubmit(event) {
      if (event.target === this.refs.queryForm) {
        event.preventDefault();
        this.submitQuery();
      } else if (event.target === this.refs.questionForm) {
        event.preventDefault();
        this.submitQuestion();
      } else if (event.target === this.refs.refinementForm) {
        event.preventDefault();
        this.submitRefinement();
      }
    }

    onClick(event) {
      const button = event.target.closest('button, a');
      if (!button || !this.contains(button)) return;
      if (button.matches('[data-oh-mode]')) {
        this.switchMode(button.dataset.ohMode, true);
      } else if (button.matches('[data-oh-guided-start]')) {
        this.startGuided();
      } else if (button.matches('[data-oh-chip-remove]')) {
        this.removePreference(button.dataset.ohChipRemove);
      } else if (button.matches('[data-oh-question-skip]')) {
        this.skipQuestion();
      } else if (button.matches('[data-oh-refine]')) {
        this.refine();
      } else if (button.matches('[data-oh-more]')) {
        this.showMoreOptions();
      } else if (button.matches('[data-oh-refinement-cancel]')) {
        this.cancelRefinement();
      } else if (button.matches('[data-oh-alternatives-toggle]')) {
        this.toggleAlternatives();
      } else if (button.matches('[data-oh-compare-open]')) {
        this.openComparison();
      } else if (button.matches('[data-oh-compare-close]')) {
        this.closeComparison(true);
      } else if (button.matches('[data-oh-compare-remove]')) {
        const removedIndex = this.state.compared.indexOf(button.dataset.ohCompareRemove);
        this.changeComparison(button.dataset.ohCompareRemove, false, null);
        if (this.state.compareOpen) {
          const remaining = [...this.refs.compareContent.querySelectorAll('[data-oh-compare-remove]')];
          this.focusElement(remaining[Math.min(Math.max(removedIndex, 0), remaining.length - 1)]);
        } else {
          this.focusElement(this.refs.compareOpen);
        }
      } else if (button.matches('[data-oh-retry]')) {
        this.retry();
      } else if (button.matches('[data-oh-reset]')) {
        this.resetAdvisor();
      } else if (button.matches('[data-oh-product-link]')) {
        this.productSelected(button);
      } else if (button.matches('[data-oh-help-link]')) {
        this.track('professional_help_opened', {
          mode: this.state.mode,
          reason: this.state.meta.status === 'handoff' ? 'handoff' : 'no_results',
          stage: 'help'
        });
      } else if (button.matches('[data-oh-fallback-link]')) {
        this.track('fallback_used', { reason: this.refs.error.hidden ? 'no_results' : 'request_error', source: 'catalogue' });
      }
    }

    onChange(event) {
      const input = event.target.closest('input[data-oh-compare]');
      if (!input || !this.contains(input)) return;
      this.changeComparison(input.dataset.ohCompare, input.checked, input);
    }

    onInput(event) {
      if (event.target === this.refs.query && cleanText(this.refs.query.value, MAX_QUERY_LENGTH)) {
        this.refs.query.removeAttribute('aria-invalid');
        this.refs.queryError.textContent = '';
        this.refs.queryError.hidden = true;
      }
    }

    onKeydown(event) {
      if (event.key === 'Escape' && this.state.compareOpen) {
        event.preventDefault();
        this.closeComparison(true);
      }
      if ((event.ctrlKey || event.metaKey) && event.key === 'Enter' && event.target === this.refs.query) {
        event.preventDefault();
        this.submitQuery();
      }
      if ((event.ctrlKey || event.metaKey) && event.key === 'Enter' && event.target === this.refs.refinementQuery) {
        event.preventDefault();
        this.submitRefinement();
      }
    }

    switchMode(mode, focus) {
      const nextMode = mode === 'guided' ? 'guided' : 'free';
      this.state.mode = nextMode;
      if (nextMode === 'guided') this.refs.query.value = '';
      this.refs.queryForm.hidden = nextMode !== 'free';
      this.refs.guided.hidden = nextMode !== 'guided';
      for (const button of this.querySelectorAll('[data-oh-mode]')) {
        button.setAttribute('aria-pressed', String(button.dataset.ohMode === nextMode));
      }
      if (focus) {
        this.track('mode_selected', { mode: nextMode, stage: 'entry' });
        this.focusElement(nextMode === 'free' ? this.refs.query : this.refs.guidedStart);
      }
    }

    submitQuery() {
      if (this.getAttribute('aria-busy') === 'true') return;
      const query = cleanText(this.refs.query.value, MAX_QUERY_LENGTH);
      if (!query) {
        this.setStatus(this.copy.queryRequired);
        this.refs.query.setAttribute('aria-invalid', 'true');
        this.refs.queryError.textContent = this.copy.queryRequired;
        this.refs.queryError.hidden = false;
        this.focusElement(this.refs.query);
        return;
      }
      this.refs.query.removeAttribute('aria-invalid');
      this.refs.queryError.textContent = '';
      this.refs.queryError.hidden = true;
      this.state.mode = 'free';
      this.state.answers = {};
      this.state.sessionState = null;
      this.track('intent_submitted', { mode: 'free', stage: 'entry' });
      this.requestRecommendations(query, { includeQuery: true, action: 'start', busyMessage: this.copy.loading });
    }

    startGuided() {
      if (this.getAttribute('aria-busy') === 'true') return;
      this.state.answers = {};
      this.state.sessionState = null;
      this.state.mode = 'guided';
      this.track('guided_started', { mode: 'guided', stage: 'entry' });
      this.requestRecommendations('', { includeQuery: false, action: 'start', busyMessage: this.copy.guidedLoading });
    }

    submitQuestion() {
      if (this.getAttribute('aria-busy') === 'true' || !this.state.question) return;
      const selectedIndexes = [...this.refs.questionOptions.querySelectorAll('input:checked')]
        .map(input => Number(input.dataset.optionIndex))
        .filter(index => Number.isInteger(index) && this.state.question.options[index]);
      if (!selectedIndexes.length) {
        this.refs.fieldError.textContent = this.state.question.allowSkip ? this.copy.questionRequired : this.copy.questionRequiredChoice;
        this.refs.fieldError.hidden = false;
        const firstInput = this.refs.questionOptions.querySelector('input');
        this.focusElement(firstInput);
        return;
      }
      this.refs.fieldError.hidden = true;
      const values = selectedIndexes.map(index => this.state.question.options[index].value);
      const answer = this.state.question.multiple ? values : values[0];
      this.state.answers = sanitizeAnswers({ ...this.state.answers, [this.state.question.id]: answer });
      this.track('question_answered', { mode: this.state.mode, question_id: this.state.question.id, stage: 'question' });
      this.requestRecommendations('', { includeQuery: false, action: 'answer', busyMessage: this.copy.loading });
    }

    skipQuestion() {
      if (this.getAttribute('aria-busy') === 'true' || !this.state.question || !this.state.question.allowSkip) return;
      const questionId = this.state.question.id;
      this.state.answers = { ...this.state.answers, [questionId]: 'skip' };
      this.track('question_skipped', { mode: this.state.mode, question_id: questionId, stage: 'question' });
      this.requestRecommendations('', { includeQuery: false, action: 'answer', busyMessage: this.copy.loading });
    }

    removePreference(key) {
      if (this.getAttribute('aria-busy') === 'true' || !SAFE_CRITERIA.has(key)) return;
      this.state.answers = { ...this.state.answers, [key]: null };
      this.track('preference_removed', { mode: this.state.mode, question_id: key, stage: 'refine' });
      this.requestRecommendations('', { includeQuery: false, action: 'answer', busyMessage: this.copy.refining });
    }

    refine() {
      if (this.getAttribute('aria-busy') === 'true') return;
      if (!this.state.meta.canRefine || this.state.refinementRound >= this.state.refinementLimit) {
        this.setStatus(this.copy.refinementLimit);
        this.track('refinement_limit_reached', { mode: this.state.mode, round: this.state.refinementRound, stage: 'refine' });
        this.focusElement(this.refs.reset);
        return;
      }
      this.state.refinementOpen = true;
      this.state.refinementError = '';
      this.renderRefinement();
      this.track('preference_refined', { mode: this.state.mode, round: this.state.refinementRound + 1, stage: 'refine' });
      this.setStatus(this.copy.refinementHelp);
      this.focusElement(this.refs.refinementQuery);
    }

    cancelRefinement() {
      this.state.refinementOpen = false;
      this.state.refinementError = '';
      this.refs.refinementQuery.value = '';
      this.refs.refinementQuery.removeAttribute('aria-invalid');
      this.renderRefinement();
      this.focusElement(this.refs.results.hidden ? this.refs.empty : this.refs.resultsTitle);
    }

    submitRefinement() {
      if (this.getAttribute('aria-busy') === 'true' || !this.state.sessionState) return;
      if (!this.state.meta.canRefine || this.state.refinementRound >= this.state.refinementLimit) {
        this.setStatus(this.copy.refinementLimit);
        return;
      }
      const query = cleanText(this.refs.refinementQuery.value, MAX_REFINEMENT_QUERY_LENGTH);
      if (!query) {
        this.state.refinementError = this.copy.refinementRequired;
        this.refs.refinementQuery.setAttribute('aria-invalid', 'true');
        this.renderRefinement();
        this.focusElement(this.refs.refinementQuery);
        return;
      }
      this.refs.refinementQuery.removeAttribute('aria-invalid');
      this.state.refinementError = '';
      this.state.answers = {};
      this.track('refinement_submitted', { mode: this.state.mode, round: this.state.refinementRound + 1, stage: 'refine' });
      this.requestRecommendations(query, {
        includeQuery: true,
        answers: {},
        action: 'refine',
        busyMessage: this.copy.refining
      });
    }

    showMoreOptions() {
      if (this.getAttribute('aria-busy') === 'true' || !this.state.sessionState) return;
      if (!this.state.meta.canRefine || this.state.refinementRound >= this.state.refinementLimit) {
        this.setStatus(this.copy.refinementLimit);
        this.track('refinement_limit_reached', { mode: this.state.mode, round: this.state.refinementRound, stage: 'refine' });
        return;
      }
      this.state.refinementError = '';
      this.state.answers = {};
      this.track('more_options_requested', { mode: this.state.mode, round: this.state.refinementRound + 1, stage: 'refine' });
      this.requestRecommendations('', {
        includeQuery: false,
        answers: {},
        action: 'more',
        busyMessage: this.copy.moreLoading
      });
    }

    retry() {
      this.refs.error.hidden = true;
      if (!this.lastRequestWasSafe || !this.lastSafeRequest) {
        if (this.lastRequestAction === 'refine' && this.state.sessionState) {
          this.state.refinementOpen = true;
          this.state.refinementError = this.copy.retryRefinement;
          this.refs.refinementQuery.removeAttribute('aria-invalid');
          this.renderRefinement();
          this.setStatus(this.copy.retryRefinement);
          this.focusElement(this.refs.refinementQuery);
          return;
        }
        this.switchMode('free', false);
        this.setStatus(this.copy.retryQuery);
        this.focusElement(this.refs.query);
        return;
      }
      this.requestRecommendations('', { ...this.lastSafeRequest });
    }

    async requestRecommendations(query, { includeQuery, answers, action = 'start', busyMessage } = {}) {
      if (this.requestController) this.requestController.abort();
      const sequence = ++this.requestSequence;
      const controller = new scope.AbortController();
      this.requestController = controller;
      const payload = buildPayload({
        query,
        locale: this.locale,
        mode: this.state.mode,
        country: this.country,
        currency: this.currency,
        answers: answers ?? this.state.answers,
        sessionState: this.state.sessionState,
        includeQuery,
        action
      });
      const body = JSON.stringify(payload);
      const sentFreeText = Boolean(payload.query);
      this.lastRequestAction = payload.action;
      this.lastRequestWasSafe = !sentFreeText;
      this.lastSafeRequest = sentFreeText
        ? null
        : {
            includeQuery: false,
            answers: payload.answers,
            action: payload.action,
            busyMessage: busyMessage || this.copy.loading
          };
      const hasStableContent = !this.refs.results.hidden
        || !this.refs.question.hidden
        || this.state.recommendations.length > 0;
      const showSkeleton = payload.action === 'start' && !hasStableContent;
      this.setBusy(true, busyMessage || this.copy.loading, { showSkeleton });
      this.refs.error.hidden = true;
      this.refs.empty.hidden = true;
      const timeoutId = scope.setTimeout(() => controller.abort(), this.requestTimeout);
      this.timeoutId = timeoutId;

      try {
        const response = await fetchWithNetworkRetry(scope.fetch.bind(scope), this.endpoint, {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body,
          credentials: 'same-origin',
          referrerPolicy: 'strict-origin-when-cross-origin',
          signal: controller.signal
        });
        if (!response.ok) throw new Error('http_error');
        const data = normalizeResponse(await response.json(), this.currency);
        if (sequence !== this.requestSequence) return;
        const applied = this.applyResponse(data);
        if (applied !== false && sentFreeText) {
          if (payload.action === 'refine') this.refs.refinementQuery.value = '';
          else if (payload.action === 'start') this.refs.query.value = '';
        }
      } catch (error) {
        if (sequence !== this.requestSequence) return;
        const timedOut = error && error.name === 'AbortError';
        const invalid = error && error.message === 'invalid_response';
        this.showError(timedOut ? 'timeout' : invalid ? 'invalid_response' : 'request_error', sentFreeText);
      } finally {
        scope.clearTimeout(timeoutId);
        if (sequence === this.requestSequence) {
          if (this.timeoutId === timeoutId) this.timeoutId = null;
          if (this.requestController === controller) this.requestController = null;
          this.setBusy(false);
        }
      }
    }

    applyResponse(data) {
      const refinementRejected = ['refinement_unrecognized', 'refinement_no_results'].includes(data.meta.status);
      if (refinementRejected) {
        this.state.answers = {};
        this.state.sessionState = data.sessionState || this.state.sessionState;
        this.state.interpreted = data.interpreted.length ? data.interpreted : this.state.interpreted;
        this.state.meta = { ...this.state.meta, ...data.meta };
        this.state.refinementRound = data.meta.refinementRound;
        this.state.refinementLimit = data.meta.refinementLimit;
        this.state.refinementOpen = true;
        this.state.refinementError = data.meta.status === 'refinement_no_results'
          ? this.copy.refinementNoResults
          : this.copy.refinementUnrecognized;
        this.refs.reset.hidden = false;
        this.renderInterpreted();
        this.renderRefinement();
        if (!this.state.recommendations.length) this.refs.empty.hidden = false;
        this.setStatus(this.state.refinementError);
        this.track('refinement_rejected', {
          mode: this.state.mode,
          reason: data.meta.status === 'refinement_no_results' ? 'no_results' : 'unrecognized',
          round: this.state.refinementRound + 1,
          stage: 'refine'
        });
        this.focusElement(this.refs.refinementQuery);
        return false;
      }

      const previousRefinementRound = this.state.refinementRound;
      this.state.answers = {};
      this.state.sessionState = data.sessionState;
      this.state.interpreted = data.interpreted;
      this.state.question = data.question;
      this.state.recommendations = data.recommendations;
      this.state.alternatives = data.alternatives;
      this.state.meta = data.meta;
      this.state.refinementRound = data.meta.refinementRound;
      this.state.refinementLimit = data.meta.refinementLimit;
      this.state.refinementOpen = false;
      this.state.refinementError = '';
      this.state.products = new Map([...data.recommendations, ...data.alternatives].map(product => [product.id, product]));
      this.state.compared = this.state.compared.filter(id => this.state.products.has(id));
      this.state.compareOpen = this.state.compareOpen && this.state.compared.length >= 2;
      this.state.alternativesOpen = false;
      this.refs.reset.hidden = false;
      const flowInProgress = Boolean(data.question || data.recommendations.length || data.alternatives.length);
      this.refs.mode.hidden = flowInProgress;
      this.refs.entry.hidden = flowInProgress;
      this.renderInterpreted();
      this.renderQuestion();
      this.renderResults();
      this.renderRefinement();
      this.renderComparison();

      const total = data.recommendations.length + data.alternatives.length;
      if (total) {
        this.setStatus(
          data.meta.refinementRound > previousRefinementRound
            ? this.copy.refinementUpdated(data.meta.newResultCount)
            : total === 1 ? this.copy.resultOne : this.copy.resultMany(total)
        );
        this.track('results_viewed', { mode: this.state.mode, result_count: total, stage: data.question ? 'question' : 'results' });
      } else if (!data.question) {
        if (data.meta.status === 'handoff') {
          this.refs.emptyTitle.textContent = this.copy.handoffTitle;
          this.refs.emptyCopy.textContent = data.meta.handoffMessage || this.copy.handoffDefault;
          this.refs.empty.querySelector('[data-oh-refine]').hidden = true;
          this.setStatus(`${this.copy.handoffTitle}. ${this.refs.emptyCopy.textContent}`);
          this.track('handoff_shown', { mode: this.state.mode, reason: data.meta.handoffCode || 'clinical', stage: 'handoff' });
        } else if (data.meta.status === 'currency_unverified') {
          this.refs.emptyTitle.textContent = this.copy.currencyTitle;
          this.refs.emptyCopy.textContent = this.copy.currencyDefault;
          this.refs.empty.querySelector('[data-oh-refine]').hidden = false;
          this.setStatus(`${this.copy.currencyTitle}. ${this.copy.currencyDefault}`);
          this.track('currency_unverified', { mode: this.state.mode, reason: 'currency', stage: 'results' });
        } else {
          this.refs.emptyTitle.textContent = this.copy.noResults;
          this.refs.emptyCopy.textContent = this.copy.noResultsCopy;
          this.refs.empty.querySelector('[data-oh-refine]').hidden = false;
          this.setStatus(this.copy.noResults);
          this.track('no_results', { mode: this.state.mode, reason: 'no_match', stage: 'results' });
        }
        this.refs.empty.hidden = false;
      }

      if (data.question) this.focusElement(this.refs.questionTitle);
      else if (total) this.focusElement(this.refs.resultsTitle);
      else this.focusElement(this.refs.empty);
      return true;
    }

    renderInterpreted() {
      this.refs.chips.replaceChildren();
      this.refs.interpreted.hidden = !this.state.interpreted.length;
      for (const criterion of this.state.interpreted) {
        const item = createNode(scope.document, 'li', 'oha-chip');
        item.append(createNode(scope.document, 'span', '', criterion.label));
        if (criterion.removable) {
          const button = createNode(scope.document, 'button', '', '×');
          button.type = 'button';
          button.dataset.ohChipRemove = criterion.key;
          button.setAttribute('aria-label', this.copy.remove(criterion.label));
          item.append(button);
        }
        this.refs.chips.append(item);
      }
    }

    renderQuestion() {
      const question = this.state.question;
      this.refs.question.hidden = !question;
      this.refs.questionOptions.replaceChildren();
      this.refs.fieldError.hidden = true;
      if (!question) return;
      this.refs.questionTitle.textContent = question.prompt;
      this.refs.questionHelp.textContent = question.help;
      this.refs.questionHelp.hidden = !question.help;
      this.refs.progress.textContent = question.step && question.total ? this.copy.progress(question.step, question.total) : '';
      this.refs.questionSkip.hidden = !question.allowSkip;
      const legend = createNode(scope.document, 'legend', 'oha-sr-only', question.prompt);
      this.refs.questionOptions.append(legend);
      question.options.forEach((option, index) => {
        const wrapper = createNode(scope.document, 'div', 'oha-option');
        const input = createNode(scope.document, 'input');
        const id = `${this.instanceId}-option-${index}`;
        input.type = question.multiple ? 'checkbox' : 'radio';
        input.name = `${this.instanceId}-answer`;
        input.id = id;
        input.dataset.optionIndex = String(index);
        const label = createNode(scope.document, 'label', '', option.label);
        label.htmlFor = id;
        wrapper.append(input, label);
        this.refs.questionOptions.append(wrapper);
      });
    }

    renderResults() {
      this.refs.recommendations.replaceChildren();
      this.refs.alternativesList.replaceChildren();
      const hasRecommendations = this.state.recommendations.length > 0;
      this.refs.results.hidden = !hasRecommendations;
      this.refs.alternatives.hidden = !this.state.alternatives.length;
      this.refs.alternativesList.hidden = true;
      this.refs.alternativesToggle.setAttribute('aria-expanded', 'false');
      if (!hasRecommendations) return;

      const visibleResultCount = this.state.recommendations.length;
      const summary = visibleResultCount === 1 ? this.copy.resultOne : this.copy.resultMany(visibleResultCount);
      const criteria = this.state.meta.criteriaCount ? ` ${this.copy.criteria(this.state.meta.criteriaCount)}` : '';
      this.refs.resultSummary.textContent = `${summary}${criteria}`;

      const notice = this.state.meta.notice || (this.state.meta.relaxed.length ? this.copy.relaxed(this.state.meta.relaxed.join(', ')) : '');
      this.refs.notice.textContent = notice;
      this.refs.notice.hidden = !notice;

      this.state.recommendations.forEach((product, index) => {
        this.refs.recommendations.append(this.productCard(product, 'recommendation', index + 1));
        this.trackProductImpression(product, 'recommendation', index + 1);
      });
      this.state.alternatives.forEach((product, index) => {
        this.refs.alternativesList.append(this.productCard(product, 'alternative', index + 4));
      });
      this.refs.alternativesToggle.textContent = this.copy.alternatives(this.state.alternatives.length);
      this.syncComparisonControls();
    }

    renderRefinement() {
      const status = this.state.meta.status || '';
      const recoverableStatus = ['results', 'no_results', 'currency_unverified', 'refinement_unrecognized', 'refinement_no_results'].includes(status);
      const available = Boolean(this.state.sessionState) && !this.state.question && recoverableStatus;
      this.refs.refinement.hidden = !available;
      if (!available) return;

      const round = Math.max(0, this.state.refinementRound);
      const limit = Math.max(1, this.state.refinementLimit || MAX_REFINEMENTS);
      const atLimit = !this.state.meta.canRefine || round >= limit;
      const nextRound = Math.min(limit, round + 1);
      this.refs.refinementProgress.textContent = atLimit
        ? this.copy.refinementProgress(limit, limit)
        : this.copy.refinementProgress(nextRound, limit);
      const remainingAfter = Math.max(0, limit - nextRound);
      this.refs.refinementHelp.textContent = remainingAfter
        ? `${this.copy.refinementHelp} ${this.copy.refinementRemaining(remainingAfter)}`
        : this.copy.refinementHelp;
      this.refs.refinementForm.hidden = atLimit || !this.state.refinementOpen;
      this.refs.refinementLimit.textContent = this.copy.refinementLimit;
      this.refs.refinementLimit.hidden = !atLimit;
      this.refs.refinementError.textContent = this.state.refinementError;
      this.refs.refinementError.hidden = !this.state.refinementError;
      for (const trigger of this.querySelectorAll('[data-oh-refine]')) {
        trigger.hidden = atLimit || this.state.refinementOpen;
        trigger.setAttribute('aria-expanded', String(!atLimit && this.state.refinementOpen));
      }
      for (const trigger of this.querySelectorAll('[data-oh-more]')) {
        trigger.hidden = atLimit;
        trigger.textContent = this.copy.moreOptions;
      }
    }

    productCard(product, sourceName, position) {
      const identity = productIdentity(product);
      const item = createNode(scope.document, 'li', 'oha-product');
      const article = createNode(scope.document, 'article');
      const href = advisorProductUrl(product.rawUrl, scope.location && scope.location.href, this.rootUrl);
      const imageLink = createNode(scope.document, 'a', 'oha-product__image');
      imageLink.href = href || this.fallbackUrl;
      imageLink.dataset.ohProductLink = product.id;
      imageLink.dataset.source = sourceName;
      imageLink.dataset.position = String(position);
      imageLink.setAttribute('aria-label', this.copy.viewProduct(identity.name));
      const imageUrl = safeImageUrl(product.imageUrl, scope.location && scope.location.href);
      if (imageUrl) {
        const image = createNode(scope.document, 'img');
        image.src = imageUrl;
        image.alt = product.imageAlt && product.imageAlt !== product.title ? product.imageAlt : identity.name;
        image.loading = 'lazy';
        image.decoding = 'async';
        imageLink.append(image);
      } else {
        imageLink.append(createNode(scope.document, 'span', 'oha-product__placeholder', product.brand || 'OpticalH'));
      }

      const body = createNode(scope.document, 'div', 'oha-product__body');
      const badge = createNode(scope.document, 'p', 'oha-product__match', product.matchTier === 'very_high' || product.matchTier === 'high' ? this.copy.recommended : this.copy.good);
      if (product.brand) body.append(createNode(scope.document, 'p', 'oha-product__brand', product.brand));
      body.append(createNode(scope.document, 'h3', '', identity.model));
      body.append(createNode(scope.document, 'p', 'oha-product__price', formatPrice(product.price, this.locale, this.copy)));
      if (product.reasons.length) {
        const explanation = createNode(scope.document, 'details', 'oha-product__explanation');
        const summary = createNode(scope.document, 'summary');
        const indicator = createNode(scope.document, 'span', 'oha-product__explanation-indicator');
        indicator.setAttribute('aria-hidden', 'true');
        summary.append(createNode(scope.document, 'span', '', this.copy.why), indicator);
        const reasons = createNode(scope.document, 'ul', 'oha-product__reasons');
        product.reasons.forEach(reason => reasons.append(createNode(scope.document, 'li', '', reason)));
        explanation.append(summary, badge, reasons);
        body.append(explanation);
      } else {
        body.append(badge);
      }
      if (product.tradeoffs.length) {
        const tradeoff = createNode(scope.document, 'p', 'oha-product__tradeoff');
        const strong = createNode(scope.document, 'strong', '', `${this.copy.consideration}: `);
        tradeoff.append(strong, scope.document.createTextNode(product.tradeoffs[0]));
        body.append(tradeoff);
      }
      if (!product.available) body.append(createNode(scope.document, 'p', 'oha-product__availability', this.copy.unavailable));

      const actions = createNode(scope.document, 'div', 'oha-product__actions');
      const compareLabel = createNode(scope.document, 'label', 'oha-product__compare');
      const compareInput = createNode(scope.document, 'input');
      compareInput.type = 'checkbox';
      compareInput.dataset.ohCompare = product.id;
      compareInput.checked = this.state.compared.includes(product.id);
      compareInput.setAttribute('aria-label', this.copy.compareProduct(identity.name));
      compareLabel.append(compareInput, createNode(scope.document, 'span', '', this.copy.compare));
      const link = createNode(scope.document, 'a', 'oha-product__cta', this.copy.view);
      link.href = href || this.fallbackUrl;
      link.dataset.ohProductLink = product.id;
      link.dataset.source = sourceName;
      link.dataset.position = String(position);
      link.setAttribute('aria-label', this.copy.viewProduct(identity.name));
      actions.append(compareLabel, link);
      body.append(actions);
      article.append(imageLink, body);
      item.append(article);
      return item;
    }

    trackProductImpression(product, sourceName, position) {
      const key = `${sourceName}:${position}:${product.id}`;
      if (this.state.impressions.has(key)) return;
      this.state.impressions.add(key);
      this.track('product_impression', {
        product_id: product.id,
        match_tier: product.matchTier,
        position,
        source: sourceName,
        stage: 'results'
      });
    }

    toggleAlternatives() {
      this.state.alternativesOpen = !this.state.alternativesOpen;
      this.refs.alternativesList.hidden = !this.state.alternativesOpen;
      this.refs.alternativesToggle.setAttribute('aria-expanded', String(this.state.alternativesOpen));
      this.refs.alternativesToggle.textContent = this.state.alternativesOpen
        ? this.copy.hideAlternatives
        : this.copy.alternatives(this.state.alternatives.length);
      if (this.state.alternativesOpen) {
        this.state.alternatives.forEach((product, index) => {
          this.trackProductImpression(product, 'alternative', index + 4);
        });
        this.track('alternatives_opened', { count: this.state.alternatives.length, mode: this.state.mode, stage: 'results' });
        const firstLink = this.refs.alternativesList.querySelector('a');
        this.focusElement(firstLink);
      }
    }

    changeComparison(productId, selected, input) {
      const result = updateComparison(this.state.compared, productId, selected);
      if (!result.accepted) {
        if (input) input.checked = false;
        this.setStatus(this.copy.compareLimit);
        return;
      }
      this.state.compared = result.ids;
      if (this.state.compared.length < 2) this.state.compareOpen = false;
      this.track(selected ? 'compare_added' : 'compare_removed', {
        product_id: productId,
        selected_count: this.state.compared.length,
        stage: 'compare'
      });
      this.renderComparison();
      this.syncComparisonControls();
      this.setStatus(this.state.compared.length < 2 ? this.copy.compareNeedMore : this.copy.compareSummary(this.state.compared.length));
    }

    syncComparisonControls() {
      const atLimit = this.state.compared.length >= MAX_COMPARE;
      for (const input of this.querySelectorAll('input[data-oh-compare]')) {
        const checked = this.state.compared.includes(input.dataset.ohCompare);
        input.checked = checked;
        input.disabled = atLimit && !checked;
      }
    }

    renderComparison() {
      const products = this.state.compared.map(id => this.state.products.get(id)).filter(Boolean);
      this.refs.compareTray.hidden = products.length === 0;
      this.refs.compareSummary.textContent = this.copy.compareSummary(products.length);
      this.refs.compareOpen.disabled = products.length < 2;
      this.refs.compare.hidden = !this.state.compareOpen || products.length < 2;
      this.refs.compareContent.replaceChildren();
      if (products.length < 2) return;

      this.refs.compareContent.tabIndex = 0;
      this.refs.compareContent.setAttribute('aria-label', this.copy.comparisonScroll);
      const table = createNode(scope.document, 'table', 'oha-compare__table');
      table.style.setProperty('--oha-compare-min-width', `${8 + (products.length * 13)}rem`);
      table.append(createNode(scope.document, 'caption', 'oha-sr-only', this.copy.comparisonCaption));
      const head = createNode(scope.document, 'thead');
      const headRow = createNode(scope.document, 'tr');
      const corner = createNode(scope.document, 'th', 'oha-compare__corner', this.copy.feature);
      corner.scope = 'col';
      headRow.append(corner);
      products.forEach((product, index) => {
        const identity = productIdentity(product);
        const heading = createNode(scope.document, 'th', 'oha-compare__product');
        heading.scope = 'col';
        const remove = createNode(scope.document, 'button', '', '×');
        remove.type = 'button';
        remove.dataset.ohCompareRemove = product.id;
        remove.setAttribute('aria-label', this.copy.removeCompare(identity.name));
        heading.append(remove);

        const imageUrl = safeImageUrl(product.imageUrl, scope.location && scope.location.href);
        const thumbnail = createNode(scope.document, 'span', 'oha-compare__thumb');
        if (imageUrl) {
          const image = createNode(scope.document, 'img');
          image.src = imageUrl;
          image.alt = '';
          image.loading = 'lazy';
          image.decoding = 'async';
          thumbnail.append(image);
        } else {
          thumbnail.append(createNode(scope.document, 'span', '', product.brand || 'OpticalH'));
        }
        heading.append(thumbnail);
        if (product.brand) heading.append(createNode(scope.document, 'span', 'oha-compare__brand', product.brand));
        heading.append(createNode(scope.document, 'span', 'oha-compare__title', identity.model));

        const href = advisorProductUrl(product.rawUrl, scope.location && scope.location.href, this.rootUrl);
        const link = createNode(scope.document, 'a', 'oha-compare__pdp', this.copy.view);
        link.href = href || this.fallbackUrl;
        link.dataset.ohProductLink = product.id;
        link.dataset.source = 'comparison';
        link.dataset.position = String(index + 1);
        link.setAttribute('aria-label', this.copy.viewProduct(identity.name));
        heading.append(link);
        headRow.append(heading);
      });
      head.append(headRow);
      table.append(head);

      const body = createNode(scope.document, 'tbody');
      const rows = [
        { key: '_price', label: this.copy.price, value: product => formatPrice(product.price, this.locale, this.copy) },
        { key: '_match', label: this.copy.match, value: product => product.matchTier === 'very_high' || product.matchTier === 'high' ? this.copy.recommended : this.copy.good },
        {
          key: '_difference',
          label: this.copy.comparisonDifference,
          value: product => product.reasons[0] || product.tradeoffs[0]
            || (product.matchTier === 'very_high' || product.matchTier === 'high' ? this.copy.recommended : this.copy.good)
        }
      ];
      const attributeKeys = [...new Set(products.flatMap(product => Object.keys(product.attributes)))].slice(0, 8);
      attributeKeys.forEach(key => rows.push({ key, label: this.copy.attributes[key] || key, value: product => localizedAttributeValue(key, product.attributes[key], this.locale) || '—' }));
      rows.forEach(row => {
        const tableRow = createNode(scope.document, 'tr');
        const heading = createNode(scope.document, 'th', '', row.label);
        heading.scope = 'row';
        tableRow.append(heading);
        products.forEach(product => tableRow.append(createNode(scope.document, 'td', '', row.value(product))));
        body.append(tableRow);
      });
      table.append(body);
      this.refs.compareContent.append(table);
    }

    openComparison() {
      if (this.state.compared.length < 2) {
        this.setStatus(this.copy.compareNeedMore);
        return;
      }
      this.state.compareOpen = true;
      this.renderComparison();
      this.track('compare_opened', { selected_count: this.state.compared.length, stage: 'compare' });
      this.focusElement(this.refs.compareTitle);
    }

    closeComparison(returnFocus) {
      this.state.compareOpen = false;
      this.refs.compare.hidden = true;
      if (returnFocus) this.focusElement(this.refs.compareOpen);
    }

    productSelected(link) {
      const productId = cleanText(link.dataset.ohProductLink, 120);
      const product = this.state.products.get(productId);
      this.track('product_opened', {
        product_id: productId,
        match_tier: product ? product.matchTier : 'unknown',
        position: Number(link.dataset.position) || 0,
        source: link.dataset.source || 'recommendation',
        stage: 'pdp'
      });
      this.dispatchEvent(new scope.CustomEvent('oh:advisor:product-selected', {
        bubbles: true,
        detail: { product_id: productId, source: 'advisor_mvp' }
      }));
    }

    showError(kind, sentFreeText) {
      this.refs.error.hidden = false;
      this.refs.errorCopy.textContent = kind === 'timeout'
        ? this.copy.timeout
        : kind === 'invalid_response'
          ? this.copy.invalidResponse
          : sentFreeText ? this.copy.retryQuery : this.copy.retrySafe;
      this.setStatus(this.refs.errorCopy.textContent);
      this.track('request_error', { mode: this.state.mode, reason: kind, stage: 'error' });
      this.focusElement(this.refs.error);
    }

    setBusy(isBusy, message, { showSkeleton = false } = {}) {
      this.setAttribute('aria-busy', String(isBusy));
      this.refs.results.setAttribute('aria-busy', String(isBusy));
      if (isBusy) this.dataset.ohBusyMode = showSkeleton ? 'initial' : 'inline';
      else delete this.dataset.ohBusyMode;
      this.refs.loading.hidden = !isBusy || !showSkeleton;
      if (isBusy && message) this.setStatus(message);
      for (const control of this.querySelectorAll('[data-oh-mode], [data-oh-query], [data-oh-submit], [data-oh-guided-start], [data-oh-question-submit], [data-oh-question-skip], [data-oh-refine], [data-oh-more], [data-oh-refinement-submit], [data-oh-refinement-cancel], [data-oh-refinement-query], [data-oh-chip-remove]')) {
        control.disabled = isBusy;
      }
    }

    resetAdvisor() {
      if (this.requestController) this.requestController.abort();
      this.requestSequence += 1;
      this.state = this.freshState();
      this.lastRequestWasSafe = false;
      this.lastSafeRequest = null;
      this.lastRequestAction = 'start';
      this.refs.chips.replaceChildren();
      this.refs.questionOptions.replaceChildren();
      this.refs.recommendations.replaceChildren();
      this.refs.alternativesList.replaceChildren();
      this.refs.compareContent.replaceChildren();
      this.refs.refinementQuery.value = '';
      this.refs.refinementQuery.removeAttribute('aria-invalid');
      this.renderInitial();
      this.setStatus(this.copy.reset);
      this.track('advisor_reset', { mode: 'free', stage: 'entry' });
      this.focusElement(this.refs.query);
    }

    setStatus(message) {
      this.refs.status.textContent = cleanText(message, 240);
    }

    focusElement(element) {
      if (!element || typeof element.focus !== 'function') return;
      const schedule = scope.requestAnimationFrame || (callback => callback());
      schedule(() => {
        try {
          element.focus({ preventScroll: false });
        } catch (_) {
          element.focus();
        }
      });
    }

    analyticsAllowed() {
      if (scope.navigator && scope.navigator.globalPrivacyControl === true) return false;
      if (this.dataset.analyticsWithoutConsent === 'true') return true;
      try {
        return Boolean(scope.Shopify && scope.Shopify.customerPrivacy && scope.Shopify.customerPrivacy.analyticsProcessingAllowed());
      } catch (_) {
        return false;
      }
    }

    track(action, details) {
      if (!this.analyticsAllowed()) return;
      const event = sanitizeAnalytics(action, {
        ...details,
        entry_source: this.entrySource || 'direct'
      });
      if (!event) return;
      if (Array.isArray(scope.dataLayer)) scope.dataLayer.push(event);
      this.dispatchEvent(new scope.CustomEvent('oh:advisor:analytics', { bubbles: true, detail: event }));
    }
  }

  if (!scope.customElements.get('oh-glasses-advisor')) {
    scope.customElements.define('oh-glasses-advisor', OHGlassesAdvisor);
  }
}(typeof globalThis !== 'undefined' ? globalThis : this));
